<template>
  <div>
    <b-card no-body :style="'color:' + d_menuData.style.color + '; background-color: ' + d_menuData.style.backgroundColor" :class="[d_fullScreenGeneral ?'full-screen-mode' :'normal-mode']">
      <b-card-header class="p-1" :style="'color:' + d_menuData.style.main_header.color + '; background-color: ' + d_menuData.style.main_header.backgroundColor">
        <b-row>
          <!-- <b-col cols="1"> </b-col> -->
          <b-col sm="12" lg="9">
            <template v-if="d_ecosystemData.data && d_ecosystemData.data.id">
              <img src="@/icon/1994916.png" style="width: 2em; margin-right: 5px; padding: 0px;" />
              <strong style="margin-right: 10px;" :title="DateFormatWithTime(d_ecosystemData.data.data.created_at)">{{ d_ecosystemData.data.label }} </strong>
              <span style="color: red;">[{{ d_ecosystemData.data.id }}] </span>,
              <!-- <i>{{ DateFormatWithTime(d_ecosystemData.data.created_at) }}</i> -->
            </template>
            <template v-if="d_ecosystemServerData.data && d_ecosystemServerData.data.id">
              <img src="@/icon/1994916.png" style="width: 2em; margin-right: 5px; padding: 0px;" />
              <strong style="margin-right: 10px;" :title="DateFormatWithTime(d_ecosystemServerData.data.created_at)">{{ d_ecosystemServerData.data.label }} </strong>
              <span style="color: red;">[{{ d_ecosystemServerData.data.id }}] </span>,
              <!-- <i>{{ DateFormatWithTime(d_ecosystemServerData.data.created_at) }}</i> -->
            </template>
            <template v-if="d_selectedApplicationData && d_selectedApplicationData.id">
              <img src="@/icon/1994916.png" style="width: 2em; margin-right: 5px; padding: 0px;" />
              <strong style="margin-right: 10px;" :title="DateFormatWithTime(d_selectedApplicationData.data.created_at)">{{ d_selectedApplicationData.label }} </strong>
              <span style="color: red;">[{{ d_selectedApplicationData.id }}] </span>,
              <!-- <i>{{ DateFormatWithTime(d_selectedApplicationData.created_at) }}</i> -->
            </template>
            <template v-if="d_applicationBranchData.data && d_applicationBranchData.data.id">
              <img src="@/icon/1994916.png" style="width: 2em; margin-right: 5px; padding: 0px;" />
              <strong style="margin-right: 10px;" :title="DateFormatWithTime(d_applicationBranchData.data.created_at)">{{ d_applicationBranchData.data.label }} </strong>
              <span style="color: red;">[{{ d_applicationBranchData.data.id }}] </span>,
              <!-- <i>{{ DateFormatWithTime(d_applicationBranchData.data.created_at) }}</i> -->
            </template>
          </b-col>
          <b-col sm="12" lg="2" style="text-align: center;">
            <strong style="color: #50afc9; text-align: right"> WamAdmin <img src="@/icon/1994869.png" style="width: 2em;" /> </strong>
          </b-col>
          <b-col sm="12" lg="1">
            <b-button class="pull-right" size="md" :variant="d_fullScreenGeneral ? 'warning' : 'white'" :style="d_fullScreenGeneral ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenGeneral ? d_fullScreenGeneral = false : d_fullScreenGeneral = true">
              <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <w-top-menu :p_menuData="d_menuData"></w-top-menu>
      <b-tabs>
        <b-tab v-if="d_ecosystemData.data" @click="d_selectedTab = 'ecosystem_details'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Ecosystem</span>
          </template>
          <template v-if="d_selectedTab === 'ecosystem_details'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" />
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row v-if="d_ecosystemData.data">
                <b-col cols="12">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_ecosystemData.data.label ? d_ecosystemData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedEcosystemWdmr()"> edit </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_ecosystemData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_ecosystemData.url_show_iframe" @click="f_goToLink(d_ecosystemData.url_show_iframe)">
                          <img :href="d_ecosystemData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_ecosystemData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_ecosystemData.data.data" @click="d_selectedTab = 'server_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Server</span>
          </template>
          <template v-if="d_selectedTab === 'server_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Server
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="friend_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_ecosystemServerData.list">
                      <b-card :style="d_ecosystemServerData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectEcosystemServer(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_ecosystemServerData.data.label ? d_ecosystemServerData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item v-if="d_ecosystemServerData.data && d_ecosystemServerData.data.id" @click="f_editSelectedEcosystemServerWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewServerToEcosystem()"> yeni sunucu ekle </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_ecosystemServerData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_ecosystemServerData.url_show_iframe" @click="f_goToLink(d_ecosystemServerData.url_show_iframe)">
                          <img :href="d_ecosystemServerData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_ecosystemServerData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_ecosystemData.data.data" @click="d_selectedTab = 'server_application_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Application</span>
          </template>
          <template v-if="d_selectedTab === 'server_application_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Application
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="friend_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_serverApplicationData.list">
                      <b-card :style="d_serverApplicationData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectServerApplication(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_serverApplicationData.data.label ? d_serverApplicationData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <template v-if="d_ecosystemServerData.data && d_ecosystemServerData.data.id">
                          <b-dropdown-item @click="f_manageServerApplications()"> sunucu uygulamalarını yönet </b-dropdown-item>
                        </template>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_serverApplicationData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_serverApplicationData.url_show_iframe" @click="f_goToLink(d_serverApplicationData.url_show_iframe)">
                          <img :href="d_serverApplicationData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_serverApplicationData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab @click="d_selectedTab = 'app_details'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Info</span>
          </template>
          <template v-if="d_selectedTab === 'app_details'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Application
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="12">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_selectedApplicationData.label ? d_selectedApplicationData.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedApplicationWdmr()"> edit </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationListData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationListData.url_show_iframe" @click="f_goToLink(d_applicationListData.url_show_iframe)">
                          <img :href="d_applicationListData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationListData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab @click="d_selectedTab = 'branch_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Branch</span>
          </template>
          <template v-if="d_selectedTab === 'branch_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Branch
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="branch_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationBranchData.list">
                      <b-card :style="d_applicationBranchData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationBranch(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationBranchData.data.label ? d_applicationBranchData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <template v-if="d_applicationBranchData.list.length > 0">
                          <b-dropdown-item @click="f_manageApplicationBranchesForMerging()">Uygulama dallarını birleştir</b-dropdown-item>
                          <template v-if="d_ecosystemData.data && d_ecosystemData.data.id && d_serverApplicationData.selected_index !== '' && d_ecosystemServerData.data && d_ecosystemServerData.data.id">
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_all_info_with_password', 'linux')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - LINUX (Bu uygulama, bu dal, tüm bilgiler) </b-dropdown-item>
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_all_info_without_password', 'linux')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - LINUX (Bu uygulama, bu dal, tüm bilgiler, şifre hariç) </b-dropdown-item>
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_app_and_branch_type', 'linux')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - LINUX (Bu uygulama, bu dal, uygulama ve dal tipi) </b-dropdown-item>
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_all_info_with_password', 'windows')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - WINDOWS (Bu uygulama, bu dal, tüm bilgiler) </b-dropdown-item>
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_all_info_without_password', 'windows')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - WINDOWS (Bu uygulama, bu dal, tüm bilgiler, şifre hariç) </b-dropdown-item>
                            <b-dropdown-item @click="f_getPullTerminalCode('this_application_this_branch_with_app_and_branch_type', 'windows')"> seçili ekosistem -> sunucu -> uygulama için pull terminal kodu - WINDOWS (Bu uygulama, bu dal, uygulama ve dal tipi) </b-dropdown-item>
                          </template>
                        </template>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationBranchData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationBranchData.url_show_iframe" @click="f_goToLink(d_applicationBranchData.url_show_iframe)">
                          <img :href="d_applicationBranchData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationBranchData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'config_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Settings</span>
          </template>
          <template v-if="d_selectedTab === 'config_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Settings
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="config_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationConfigData.list">
                      <b-card :style="d_applicationConfigData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationConfig(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationConfigData.data.label ? d_applicationConfigData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedConfigWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_appconfigs')"> update code pages from config list </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationConfigData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationConfigData.url_show_iframe" @click="f_goToLink(d_applicationConfigData.url_show_iframe)">
                          <img :href="d_applicationConfigData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationConfigData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <!-- CODE PAGE CODE PAGE CODE PAGE -->
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'codepage_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Code Page</span>
          </template>
          <template v-if="d_selectedTab === 'codepage_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Code Page
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="branch_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationCodepageData.list">
                      <b-card :style="d_applicationCodepageData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationCodepage(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationCodepageData.data.label ? d_applicationCodepageData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedCodePagesWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewCodepageToApplication()"> yeni kod sayfası ekle </b-dropdown-item>
                        <b-dropdown-item @click="f_showCodeLink(d_applicationCodepageData.url_show_iframe)">Kod linkini al</b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationCodepageData.selected_index !== ''" @click="f_trashCodePage()"> kod sayfasını çöpe taşı </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationCodepageData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationCodepageData.url_show_iframe" @click="f_goToLink(d_applicationCodepageData.url_show_iframe)">
                          <img :href="d_applicationCodepageData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationCodepageData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <!-- FRIEND FRIEND FRIEND -->
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'friend_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Friend</span>
          </template>
          <template v-if="d_selectedTab === 'friend_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Friend
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="friend_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationFriendData.list">
                      <b-card :style="d_applicationFriendData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationFriend(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationFriendData.data.label ? d_applicationFriendData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedFriendWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_appfriends')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewFriendToApplication()"> new friend </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationFriendData.selected_index !== ''" @click="f_trashFriend()"> arkadaş uygulamayı çöpe taşı </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationFriendData.selected_index !== ''" @click="f_addNewFriendToApplicationByCloning()"> new friend by cloning selected friend </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationFriendData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationFriendData.url_show_iframe" @click="f_goToLink(d_applicationFriendData.url_show_iframe)">
                          <img :href="d_applicationFriendData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationFriendData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'route_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Route</span>
          </template>
          <template v-if="d_selectedTab === 'route_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Route
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="route_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationRouteData.list">
                      <b-card :style="d_applicationRouteData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationRoute(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationRouteData.data.label ? d_applicationRouteData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedRouteWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_approutes')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewRouteToApplication()"> new rote </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationRouteData.selected_index !== ''" @click="f_trashApplicationRoute()"> trash route </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationRouteData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationRouteData.url_show_iframe" @click="f_goToLink(d_applicationRouteData.url_show_iframe)">
                          <img :href="d_applicationRouteData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationRouteData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'statuscode_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Status Code</span>
          </template>
          <template v-if="d_selectedTab === 'statuscode_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Status Code
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="statuscode_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationStatuscodeData.list">
                      <b-card :style="d_applicationStatuscodeData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationStatuscode(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationStatuscodeData.data.label ? d_applicationStatuscodeData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedStatuscodeWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_appstatuscodes')"> update code pages from config list </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationStatuscodeData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationStatuscodeData.url_show_iframe" @click="f_goToLink(d_applicationStatuscodeData.url_show_iframe)">
                          <img :href="d_applicationStatuscodeData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationStatuscodeData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'id_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Id & Value</span>
          </template>
          <template v-if="d_selectedTab === 'id_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Id & Value
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="id_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationIdData.list">
                      <b-card :style="d_applicationIdData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationId(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationIdData.data.label ? d_applicationIdData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedIdDataWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_appids')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewIdDataToApplication()"> new id & value </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationIdData.selected_index !== ''" @click="f_trashApplicationId()"> trash id & value </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationIdData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationIdData.url_show_iframe" @click="f_goToLink(d_applicationIdData.url_show_iframe)">
                          <img :href="d_applicationIdData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationIdData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'location_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Location</span>
          </template>
          <template v-if="d_selectedTab === 'location_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Location
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="location_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationLocationData.list">
                      <b-card :style="d_applicationLocationData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationLocation(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationLocationData.data.label ? d_applicationLocationData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedLocationWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_applocations')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewLocationToApplication()"> new location </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationLocationData.selected_index !== ''" @click="f_trashLocation()"> trash location </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationLocationData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationLocationData.url_show_iframe" @click="f_goToLink(d_applicationLocationData.url_show_iframe)">
                          <img :href="d_applicationLocationData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationLocationData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'requirement_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Requirement</span>
          </template>
          <template v-if="d_selectedTab === 'requirement_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Requirement
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="requirement_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationRequirementData.list">
                      <b-card :style="d_applicationRequirementData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationRequirement(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationRequirementData.data.label ? d_applicationRequirementData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedRequirementWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_apprequirements')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewRequirementToApplication()"> new requirement </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationRequirementData.selected_index !== ''" @click="f_trashRequirement()"> trash requirement </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationRequirementData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationRequirementData.url_show_iframe" @click="f_goToLink(d_applicationRequirementData.url_show_iframe)">
                          <img :href="d_applicationRequirementData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationRequirementData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
        <b-tab v-if="d_applicationBranchData.data" @click="d_selectedTab = 'version_list'">
          <template slot="title">
            <img src="@/icon/665778.png" style="width: 1.5em;">
            <span :style="'color:' + d_menuData.style.tab_header.color">Version</span>
          </template>
          <template v-if="d_selectedTab === 'version_list'">
            <b-card no-body :class="[d_fullScreenOperationPage ?'full-screen-mode' :'normal-mode']">
              <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                <b-row>
                  <b-col sm="12" lg="2">
                    <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> Version
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="3">
                    <!-- <b-form-input class="pull-right" style="width: 100%; margin-right: 5px;" v-model="d_filter.search_text" type="text" placeholder="operasyon adı veya açıklaması" @dblclick="d_filter.search_text = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <span style="margin-top: 10px;">Op. No:</span> -->
                    <!-- <b-form-input class="pull-right" style="width: 100px; margin-right: 5px;" v-model="d_filter.operation_no" type="text" placeholder="operasyon no ile filtreleme" @dblclick="d_filter.operation_no = ''"></b-form-input> -->
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-button class="pull-right" size="md" :variant="d_fullScreenOperationPage ? 'warning' : 'white'" :style="d_fullScreenOperationPage ? 'margin-right: 5px; padding: 0px; border: solid 2px green;' : 'margin-right: 5px; padding: 0px;'" @click="d_fullScreenOperationPage ? d_fullScreenOperationPage = false : d_fullScreenOperationPage = true">
                      <img src="@/icon/629153.png" title="Tam ekran" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-row>
                <b-col cols="4">
                  <div id="version_list" :style="f_calculateBottomTabStyle()">
                    <template v-for="(x, x_ind) in d_applicationVersionData.list">
                      <b-card :style="d_applicationVersionData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplicationVersion(x_ind)">
                        <b-col cols="12">
                          {{ x_ind + 1 }} - {{ x.label }} <small>[ {{ x.id }} ]</small>
                        </b-col>
                        <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                      </b-card>
                    </template>
                  </div>
                </b-col>
                <b-col cols="8">
                  <b-card no-body>
                    <b-card-header class="p-1" :style="'min-height: 40px; color:' + d_menuData.style.tab_header.color + '; background-color: ' + d_menuData.style.tab_header.backgroundColor">
                      <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 2em;" /> {{ d_applicationVersionData.data.label ? d_applicationVersionData.data.label : 'Detaylar' }}
                      <b-dropdown variant="success" size="md" class="pull-right" right>
                        <template slot="button-content"> </template>
                        <b-dropdown-item @click="f_editSelectedVersionWdmr()"> edit </b-dropdown-item>
                        <b-dropdown-item @click="f_updateCodePagesFromConfig('system_users_appprojects_appbranchs_appversions')"> update code pages from config list </b-dropdown-item>
                        <b-dropdown-item @click="f_addNewVersionToApplication()"> new version </b-dropdown-item>
                        <b-dropdown-item v-if="d_applicationVersionData.selected_index !== ''" @click="f_trashVersion()"> trash version </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-row v-if="d_applicationVersionData.url_show_iframe">
                      <b-col sm="12" md="12">
                        <div class="wdmr-link" :title="d_applicationVersionData.url_show_iframe" @click="f_goToLink(d_applicationVersionData.url_show_iframe)">
                          <img :href="d_applicationVersionData.url_show_iframe" target="_blank" src="@/icon/201295.png" width="20px" style="border-radius: 3px; cursor: pointer;" />
                        </div>
                        <iframe :src="d_applicationVersionData.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-tab>
      </b-tabs>
    </b-card>
    <!--  -->
    <!--  -->
    <!--  -->
    <b-modal v-if="d_wisdomData.show" v-model="d_wisdomData.show" centered class="modal-success" @ok="d_wisdomData.show = false" ok-variant="success" hide-footer size="lg">
      <iframe :src="d_wisdomData.url_iframe" style="width: 100%; min-height: 500px;"></iframe>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <b-button type="button" variant="danger" @click="d_wisdomData.show = false">{{ $t('wdm16.4053') }}</b-button>
          <button type="button" class="btn btn-success" v-on:click="f_completeWdmrSave()"> İşlemi tamamla </button>
        </b-col>
      </b-row>
    </b-modal>
    <!--  -->
    <!--  -->
    <!--  -->
    <modal v-if="d_taskDocuments.show" @close="d_taskDocuments.show = false" :width="'750'">
      <h3 slot="header">
        <img src="@/icon/1519119.png" width="20px" style="border-radius: 3px;" />
        Dokümanlar
      </h3>
      <div slot="body">
        <b-form-file @input="f_addDocumentFastToTask(d_taskDocuments.task_ind)" style="height: 100px; border: dotted 2px #25bcff; background: #daf9ff;" v-model="d_tmpFile" :accept="f_createAcceptedDocumentTypes()" :placeholder="$t('wdm16.13222')" :drop-placeholder="$t('wdm16.13223')">
          <img src="@/icon/1530793.png" style="width: 2em;">
        </b-form-file>
        <template v-if="d_showTaskDocumentField && d_taskDocuments.task.document_list && d_taskDocuments.task.document_list.length > 0" v-for="(doc, doc_ind) in d_taskDocuments.task.document_list">
          <div style="margin: 5px;">
            <b-row style="margin: 0px;">
              <b-col cols="6">
                <b-button style="margin-right: 5px;" size="sm" variant="danger" @click="f_deleteDocumentInTask(d_taskDocuments.task_ind, doc_ind)"> <i class="fa fa-trash"></i> sil </b-button> {{ doc_ind + 1 }} ) {{ doc.file_name }}
              </b-col>
              <b-col cols="6">
                <b-button style="margin-right: 5px;" size="sm" v-if="['jpeg', 'png', 'jpg'].indexOf(doc.fileExtension.toLowerCase()) !== -1" variant="primary" @click="f_previewImage(d_taskDocuments.task, doc_ind, doc.file_name)">önizle</b-button>
                <b-button style="margin-right: 5px;" size="sm" variant="secondary" @click="f_downloadDocument(d_taskDocuments.task, doc_ind, doc.file_name)">indir</b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </div>
      <div slot="footer">
        <b-button variant="danger" @click="d_taskDocuments.show = false">{{ $t('wdm16.4053') }}</b-button>
      </div>
    </modal>
    <modal v-if="show_image_show_modal" @close="show_image_show_modal = false" :width="'1000'">
      <h3 slot="header">{{ document_show_data.file_name }}</h3>
      <div slot="body">
        <div>
          <b-button variant="white" @click="f_rotateImage()" title="saat yönünde döndür">
            <img src="@/icon/615577.png" style="width: 2em;">
          </b-button>
          <b-button variant="white" @click="f_scaleImageBig()" title="yaklaş">
            <img src="@/icon/425490.png" style="width: 2em;">
          </b-button>
          <b-button variant="white" @click="f_scaleImageSmall()" title="uzaklaş">
            <img src="@/icon/248972.png" style="width: 2em;">
          </b-button>
        </div>
        <div style="overflow-x: auto; overflow-y: auto; min-height: 500px; border: solid 1px black;">
          <img :style="'transform: scale(' + d_scale.toString() + ', ' + d_scale.toString() + ') rotate(' + rotate_degree.toString() + 'deg); position: relative;'" :src="document_show_data.file">
        </div>
      </div>
      <div slot="footer">
        <b-button variant="success" @click="show_image_show_modal = false">{{ $t('wdm16.4053') }}</b-button>
      </div>
    </modal>
    <b-modal v-if="d_showWdmrPreview.show" v-model="d_showWdmrPreview.show" title="Detaylar" centered class="modal-success" @ok="d_showWdmrPreview.show = false" scrollable ok-variant="success" size="lg">
      <iframe :src="d_showWdmrPreview.url_show_iframe" style="width: 100%; min-height: 500px;"></iframe>
      <template slot="modal-footer">
        <button type="button" class="btn btn-danger" @click="d_showWdmrPreview.show = false">{{ $t('wdm16.4053') }}</button>
      </template>
    </b-modal>
    <modal v-if="show_wisdom_data_modal" @close="show_wisdom_data_modal = false" :width="'750'">
      <h3 slot="header"> Operasyon Ekranı </h3>
      <div slot="body">
        <wisdom-data-modal ref="wisdom_data_modal" :data="wisdom_data" :data_type="'wdm17'" :option_data="option_data" :rule_engine="false" :query_list="[]" :p_selectedAnatomySchemaList="d_selectedAnatomySchemaList"></wisdom-data-modal>
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-success" v-on:click="f_saveTask()">{{ $t('wdm16.4061') }}</button>
        <button type="button" class="btn btn-danger" @click="show_wisdom_data_modal = false">{{ $t('wdm16.4053') }}</button>
      </div>
    </modal>
    <b-modal v-if="d_applicationListData.show" :title="'Application Projects'" centered class="modal-success" v-model="d_applicationListData.show" @ok="d_applicationListData.show = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_applicationListData.list">
            <b-card :style="d_applicationListData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectApplication(x_ind); f_cancelAllSelections()">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_managerServerApplications.show" :title="'Sunucu Uygulama Yönetimi'" centered class="modal-success" v-model="d_managerServerApplications.show" @ok="d_managerServerApplications.show = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_applicationListData.list">
            <b-card :style="d_managerServerApplications.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectForServer(x_ind)">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <button type="button" class="btn btn-success" @click="f_addApplicationToServer()">Uygulamayı Sunucuya Ekle</button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_ecosystemData.show" :title="'Ecosystem List'" centered class="modal-success" v-model="d_ecosystemData.show" @ok="d_ecosystemData.show = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_ecosystemData.list">
            <b-card :style="d_ecosystemData.selected_index === x_ind ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectEcosystem(x_ind)">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_managerApplicationBranches.show" :title="'Merge Branches In Application'" centered class="modal-success" v-model="d_managerApplicationBranches.show" @ok="d_managerApplicationBranches.show = false" ok-variant="success" hide-footer size="lg">
      <b-card style="margin-bottom: 3px;" no-body>
        <b-card-header class="p-1"> Branch Selection </b-card-header>
        <b-card style="margin-bottom: 3px;" no-body>
          <b-row style="margin: 0px;">
            <b-col cols="6">
              <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> From branch
            </b-col>
            <b-col cols="6">
              <template v-for="(x, x_ind) in d_applicationBranchData.list">
                <b-card :style="d_managerApplicationBranches.selected_index_from === x_ind ? 'background: #9adcd3; font-weight: bold; margin-bottom: 3px; cursor: pointer; min-height: 33px' : 'margin-bottom: 3px; cursor: pointer; min-height: 33px'" no-body @click="f_selectApplicationBranchForMerging(x_ind, 'selected_index_from')">
                  <b-col cols="12">
                    {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
                  </b-col>
                  <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                </b-card>
              </template>
            </b-col>
          </b-row>
        </b-card>
        <b-card style="margin-bottom: 3px;" no-body>
          <b-row style="margin: 0px;">
            <b-col cols="6">
              <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> To branch
            </b-col>
            <b-col cols="6">
              <template v-for="(x, x_ind) in d_applicationBranchData.list">
                <b-card :style="d_managerApplicationBranches.selected_index_to === x_ind ? 'background: #9adcd3; font-weight: bold; margin-bottom: 3px; cursor: pointer; min-height: 33px' : 'margin-bottom: 3px; cursor: pointer; min-height: 33px'" no-body @click="f_selectApplicationBranchForMerging(x_ind, 'selected_index_to')">
                  <b-col cols="12">
                    {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
                  </b-col>
                  <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                </b-card>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </b-card>
      <b-card style="margin-bottom: 3px;" no-body>
        <b-card-header class="p-1"> Select merge parts </b-card-header>
        <template v-for="(x, x_ind) in d_managerApplicationBranches.settings_order">
          <b-card style="margin-bottom: 3px;" no-body>
            <b-row style="margin: 0px; min-height: 33px">
              <b-col cols="6">
                <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> {{ d_managerApplicationBranches.settings[x].label }}
              </b-col>
              <b-col cols="6">
                <b-card :style="d_managerApplicationBranches.settings[x].merge === 'yes' ? 'background: #9adcd3; cursor: pointer; min-height: 33px; text-align: center; font-weight: bold;' : 'cursor: pointer; min-height: 33px; text-align: center;'" no-body @click="f_updateMergeOption(x)">
                  <b-col cols="12">
                    {{ d_managerApplicationBranches.settings[x].merge === 'yes' ? 'Yes' : 'No' }}
                  </b-col>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-card>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <button type="button" class="btn btn-success" @click="f_mergeBranches()">start merge process</button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_mergeManyApps.show" :title="'Merge Branches Between Applications'" centered class="modal-success" v-model="d_mergeManyApps.show" @ok="d_mergeManyApps.show = false" ok-variant="success" hide-footer size="lg">
      <b-card style="margin-bottom: 3px;" no-body>
        <b-card-header class="p-1"> From Application And Branch </b-card-header>
        <b-card style="margin-bottom: 3px;" no-body>
          <b-row style="margin: 0px;">
            <b-col cols="6">
              <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> From Application
            </b-col>
            <b-col cols="6">
              <b-card no-body @click="f_selectApplicationForMergingModal()" style="cursor: pointer; min-height: 33px;">
                <b-row v-if="d_mergeManyApps.selected_app_and_branch_from">
                  <b-col cols="12">
                    <img src="@/icon/2486994.png" style="width: 1.5em; margin-right: 5px; padding: 0px;" /> {{ d_mergeManyApps.selected_app_and_branch_from.label }}
                    <small style="color: blue;">
                      [ id: {{ d_mergeManyApps.selected_app_and_branch_from.id }} ]
                    </small>
                  </b-col>
                </b-row>
                <b-row v-if="!d_mergeManyApps.selected_app_and_branch_from">
                  <b-col cols="12">Please select an application</b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row style="margin: 0px;">
            <b-col cols="6">
              <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> From Application Branch
            </b-col>
            <b-col cols="6">
              <b-card no-body @click="f_selectApplicationBranchForMergingModal()" style="cursor: pointer; min-height: 33px;">
                <b-row v-if="d_mergeManyApps.selected_app_and_branch_from && d_mergeManyApps.selected_app_and_branch_from.branch">
                  <b-col cols="12">
                    <img src="@/icon/136161.png" style="width: 1.5em; margin-right: 5px; padding: 0px;" /> {{ d_mergeManyApps.selected_app_and_branch_from.branch.label }}
                    <small style="color: blue;">
                      [ id: {{ d_mergeManyApps.selected_app_and_branch_from.branch.id }} ]
                    </small>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col cols="12">Please select a branch</b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
        <!-- To Application List -->
        <b-card style="margin-bottom: 3px;" no-body>
          <b-card-header class="p-1">
            To Applications And Branches
            <b-button class="pull-right" size="md" variant="white" @click="f_selectToApplicationForMergingModal()">
              <img src="@/icon/1886795.png" style="width: 2em;" />
            </b-button>
          </b-card-header>
          <template v-for="(to_app, to_app_ind) in d_mergeManyApps.selected_app_and_branch_list_to">
            <b-row style="margin: 0px; border-bottom: solid 1px #adddff; margin-bottom: 5px;">
              <b-col cols="6">
                <b-row>
                  <b-col cols="12">
                    <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> {{ to_app.label }}
                    <small style="color: blue;">[ id: {{ to_app.id }} ]</small>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-button class="pull-right" size="md" variant="white" @click="f_deleteToApp(to_app_ind)">
                      <img src="@/icon/2960590.png" style="width: 2em;" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <template v-for="(branch, branch_ind) in to_app.branch_list">
                  <b-card :style="to_app.selected_branch && to_app.selected_branch.id === branch.id ? 'background: #9adcd3; font-weight: bold; margin-bottom: 3px; cursor: pointer; min-height: 33px' : 'margin-bottom: 3px; cursor: pointer; min-height: 33px'" no-body @click="f_selectToAppBranch(to_app_ind, branch)">
                    <b-col cols="12">
                      {{ branch_ind + 1 }} - {{ branch.label }} <small style="color: blue;">[ id: {{ branch.id }} ]</small>
                    </b-col>
                    <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
                  </b-card>
                </template>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </b-card>
      <b-card style="margin-bottom: 3px;" no-body>
        <b-card-header class="p-1"> Select merge parts </b-card-header>
        <template v-for="(x, x_ind) in d_mergeManyApps.settings_order">
          <b-card style="margin-bottom: 3px;" no-body>
            <b-row style="margin: 0px; min-height: 33px">
              <b-col cols="6">
                <img src="@/icon/934385.png" style="width: 2em; margin-right: 5px; padding: 0px;" /> {{ d_mergeManyApps.settings[x].label }}
              </b-col>
              <b-col cols="6">
                <b-card :style="d_mergeManyApps.settings[x].merge === 'yes' ? 'background: #9adcd3; cursor: pointer; min-height: 33px; text-align: center; font-weight: bold;' : 'cursor: pointer; min-height: 33px; text-align: center;'" no-body @click="f_updateMergeManyOption(x)">
                  <b-col cols="12">
                    {{ d_mergeManyApps.settings[x].merge === 'yes' ? 'Yes' : 'No' }}
                  </b-col>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-card>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <button type="button" class="btn btn-success" @click="f_mergeMultiApps()">start merge process</button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_mergeManyApps.show_from_modal" :title="'Kaynak Uygulama Seçim Ekranı'" centered class="modal-success" v-model="d_mergeManyApps.show_from_modal" @ok="d_mergeManyApps.show_from_modal = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_applicationListData.list">
            <b-card :style="d_mergeManyApps.selected_app_and_branch_from && d_mergeManyApps.selected_app_and_branch_from.id === x.id ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectAppFrom(x)">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_mergeManyApps.show_to_modal" :title="'Hedef Uygulama Seçim Ekranı'" centered class="modal-success" v-model="d_mergeManyApps.show_to_modal" @ok="d_mergeManyApps.show_to_modal = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_applicationListData.list">
            <b-card style="margin-bottom: 3px; cursor: pointer;" no-body @click="f_selectAppTo(x)">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_mergeManyApps.show_from_app_branch_model" :title="'Kaynak Uygulama Dalı Seçim Ekranı'" centered class="modal-success" v-model="d_mergeManyApps.show_from_app_branch_model" @ok="d_mergeManyApps.show_from_app_branch_model = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-for="(x, x_ind) in d_mergeManyApps.selected_app_and_branch_from.branch_list">
            <b-card :style="d_mergeManyApps.selected_app_and_branch_from && d_mergeManyApps.selected_app_and_branch_from.branch && d_mergeManyApps.selected_app_and_branch_from.branch.id === x.id ? 'background: #9adcd3; margin-bottom: 3px; cursor: pointer;' : 'margin-bottom: 3px; cursor: pointer;'" no-body @click="f_selectAppBranchFrom(x)">
              <b-col cols="12">
                {{ x_ind + 1 }} - {{ x.label }} <small style="color: blue;">[ id: {{ x.id }} ]</small>
              </b-col>
              <!-- <b-card-footer footer-bg-variant="primary" header-text-variant="dark" class="p-1" style="background-color: #5db5bd!important;"></b-card-footer> -->
            </b-card>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <modal v-if="d_ecosystemApplicationDatabaseConn.show" @close="d_ecosystemApplicationDatabaseConn.show = false" :width="'1250'">
      <h3 slot="header">
        <img src="@/icon/1519119.png" width="20px" style="border-radius: 3px;" />
        Ekosistem Veritabanı Bağlantı Ekranı
      </h3>
      <div slot="body">
        <b-row v-if="d_ecosystemApplicationDatabaseConn.view_mode === 'table'" style="margin: 10px;">
          <b-col cols="2">
            Satır Adedi: {{ d_ecosystemApplicationDatabaseConn.count }}
          </b-col>
          <b-col cols="2">
            <b-button v-if="d_ecosystemApplicationDatabaseConn.table_body.length !== d_ecosystemApplicationDatabaseConn.count" variant="white" style="padding: 0px;" @click="f_clearAllFilterColumns()">
              <img src="@/icon/1517831.png" style="width: 1.5em; margin-left: 5px; padding: 0px;" /> Tüm filtreleri temizle
            </b-button>
          </b-col>
          <b-col cols="2">
            <b-button variant="white" style="padding: 0px;" @click="d_ecoAppConfigColumn.show = true">
              <img src="@/icon/3162318.png" style="width: 1.5em; margin-left: 5px; padding: 0px;" /> Kolon Seçimi
            </b-button>
          </b-col>
        </b-row>
        <b-row style="margin: 10px; overflow-x: auto; height: 500px;">
          <b-col cols="12">
            <table style="width: 100%;">
              <thead>
                <tr style="border-bottom: solid 1px #c1c7cc;">
                  <template v-for="(caption, caption_ind) in d_ecosystemApplicationDatabaseConn.table_header">
                    <th v-if="d_ecoAppConfigColumn.show_columns.length === 0 || d_ecoAppConfigColumn.show_columns.indexOf(caption_ind) !== -1" class="th-class">
                      <div> {{ caption.label }} </div>
                      <div style="text-align: right;">
                        <b-button variant="white" style="padding: 0px;" @click="f_ecoAppConnCaptionUpdate(caption_ind, caption)">
                          <img src="@/icon/3094236.png" style="width: 1.5em; margin-left: 5px; padding: 0px;" />
                        </b-button>
                        <b-button v-if="caption.selected_options.length > 0" variant="white" style="padding: 0px;" @click="f_clearFilterColumn(caption_ind, caption)">
                          <img src="@/icon/1517831.png" style="width: 1.5em; margin-left: 5px; padding: 0px;" />
                        </b-button>
                      </div>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <template v-for="(row, row_index) in d_ecosystemApplicationDatabaseConn.table_body">
                  <tr v-if="f_filterRows(row_index)" style="border-bottom: solid 1px #c1c7cc;">
                    <template v-for="(col, col_index) in row">
                      <td v-if="d_ecoAppConfigColumn.show_columns.length === 0 || d_ecoAppConfigColumn.show_columns.indexOf(col_index) !== -1" class="td-class" :style="f_calculateTableTdStyle(col)">
                        <template v-if="d_ecosystemApplicationDatabaseConn.table_header[col_index].editable === 'no'">
                          <div> {{ col.label }} </div>
                          <div style="text-align: center;"> <small v-if="col.id !== undefined" style="color: blue;">[ id: {{ col.id }} ]</small> </div>
                        </template>
                        <template v-else-if="d_ecosystemApplicationDatabaseConn.table_header[col_index].editable === 'yes'">
                          <template v-if="['textarea', 'text', 'integer', 'float'].indexOf(d_ecosystemApplicationDatabaseConn.table_header[col_index].type) !== -1">
                            <template v-if="col.new_value !== col.label">
                              <del> {{ col.label }} </del>
                              <del style="text-align: center;"> <small v-if="col.id !== undefined" style="color: blue;">[ id: {{ col.id }} ]</small> </del>
                              <div> <i style="font-size: 14px; color: green;" class="fa fa-plus"></i> {{ col.new_value }} </div>
                            </template>
                            <template v-else>
                              <div> {{ col.label }} </div>
                              <div style="text-align: center;"> <small v-if="col.id !== undefined" style="color: blue;">[ id: {{ col.id }} ]</small> </div>
                            </template>
                          </template>
                          <template v-else-if="['select', 'radiogroup'].indexOf(d_ecosystemApplicationDatabaseConn.table_header[col_index].type) !== -1" style="min-width: 100px;">
                            <template v-if="col.new_value !== '' && col.new_value.label !== col.label">
                              <del> {{ col.label }} </del>
                              <del style="text-align: center;"> <small v-if="col.id !== undefined" style="color: blue;">[ id: {{ col.id }} ]</small> </del>
                              <div> {{ col.new_value.label }} </div>
                            </template>
                            <template v-else>
                              <div> {{ col.label }} </div>
                              <div style="text-align: center;"> <small v-if="col.id !== undefined" style="color: blue;">[ id: {{ col.id }} ]</small> </div>
                            </template>
                          </template>
                        </template>
                        <div v-if="d_ecosystemApplicationDatabaseConn.table_header[col_index].editable === 'yes'" style="text-align: right;">
                          <span @click="f_ecoAppConnCellUpdate(row_index, col_index, col)"><i class="fa fa-edit"></i></span>
                          <!-- 
                            <b-button v-if="d_ecosystemApplicationDatabaseConn.table_header[col_index].editable === 'yes'" variant="white" style="padding: 0px;" @click="f_ecoAppConnCellUpdate(row_index, col_index, col)">
                              <img src="@/icon/3094236.png" style="width: 1.5em; margin-left: 5px; padding: 0px;" />
                            </b-button>
                           -->
                        </div>
                      </td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <b-button variant="danger" @click="d_ecosystemApplicationDatabaseConn.show = false">{{ $t('wdm16.4053') }}</b-button>
        <b-button variant="success" @click="f_applyEcoAppDatabaseConnChanges()">Değişiklikleri Uygula</b-button>
      </div>
    </modal>
    <b-modal v-if="d_ecoAppConnCellUpdate.show" :title="'Hücre düzenleme'" centered class="modal-success" v-model="d_ecoAppConnCellUpdate.show" @ok="d_ecoAppConnCellUpdate.show = false" ok-variant="success" hide-footer>
      <b-row>
        <b-col cols="12">
          <template v-if="d_ecoAppConnCellUpdate.cell_data">
            <template v-if="d_ecosystemApplicationDatabaseConn.table_header[d_ecoAppConnCellUpdate.col_index].editable === 'yes'">
              <template v-if="['textarea', 'text', 'integer', 'float'].indexOf(d_ecosystemApplicationDatabaseConn.table_header[d_ecoAppConnCellUpdate.col_index].type) !== -1">
                <b-textarea v-model="d_ecoAppConnCellUpdate.cell_data.new_value" style="width: 100%;"></b-textarea>
              </template>
              <template v-else-if="['select', 'radiogroup'].indexOf(d_ecosystemApplicationDatabaseConn.table_header[d_ecoAppConnCellUpdate.col_index].type) !== -1" style="min-width: 100px;">
                <b-form-select v-model="d_ecoAppConnCellUpdate.cell_data.new_value">
                  <option v-for="(op, op_ind) in d_ecosystemApplicationDatabaseConn.table_header[d_ecoAppConnCellUpdate.col_index].possible_options" :value="op"> {{ op.label }}</option>
                </b-form-select>
              </template>
            </template>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <b-button variant="warning" @click="d_ecoAppConnCellUpdate.show = false">iptal</b-button>
          <b-button variant="success" @click="f_updateEcoAppConnCell()">güncelle</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_ecoAppConnCaptionUpdate.show" :title="'Hücre düzenleme'" centered class="modal-success" v-model="d_ecoAppConnCaptionUpdate.show" @ok="d_ecoAppConnCaptionUpdate.show = false" ok-variant="success" hide-footer size="xl">
      <b-row>
        <b-col cols="12">
          <template v-if="d_ecoAppConnCaptionUpdate.caption_data">
            <template v-if="d_ecoAppConnCaptionUpdate.caption_data.editable === 'yes'">
              <template v-if="['textarea', 'text', 'integer', 'float'].indexOf(d_ecoAppConnCaptionUpdate.caption_data.type) !== -1">
                <b-textarea v-model="d_ecoAppConnCaptionUpdate.new_value" style="width: 100%;"></b-textarea>
              </template>
              <template v-else-if="['select', 'radiogroup'].indexOf(d_ecoAppConnCaptionUpdate.caption_data.type) !== -1">
                <b-form-select v-model="d_ecoAppConnCaptionUpdate.new_value">
                  <option v-for="(op, op_ind) in d_ecoAppConnCaptionUpdate.caption_data.possible_options" :value="op"> {{ op.label }}</option>
                </b-form-select>
              </template>
            </template>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox-group stacked v-model="d_ecoAppConnCaptionUpdate.selected_options">
            <template v-for="(op, op_ind) in d_ecoAppConnCaptionUpdate.caption_data.options">
              <b-form-checkbox v-if="op.label" :value="op.label" :style="op.style"> {{ op.label }} (adet = {{ op.count }}) </b-form-checkbox>
            </template>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols="12">
          <b-form-checkbox-group stacked>
            <template v-for="(op, op_ind) in d_ecoAppConnCaptionUpdate.caption_data.possible_options">
              <b-form-checkbox v-if="op.label" :value="op" :style="op.style"> {{ op.label }} </b-form-checkbox>
            </template>
          </b-form-checkbox-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <b-button variant="warning" @click="d_ecoAppConnCaptionUpdate.show = false" style="margin-right: 10px;">iptal</b-button>
          <b-button variant="success" @click="f_applyFilterForColumns()" style="margin-right: 10px;">Filtre Uygula</b-button>
          <b-button variant="success" @click="f_updateEcoAppConnAllCells()" style="margin-right: 10px;">Tüm hücreleri güncelle</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_ecoAppConfigColumn.show" :title="'Kolon Seçimi'" centered class="modal-success" v-model="d_ecoAppConfigColumn.show" @ok="d_ecoAppConfigColumn.show = false" ok-variant="success" hide-footer size="xl">
      <b-row>
        <b-col cols="12">
          <b-form-checkbox-group stacked v-model="d_ecoAppConfigColumn.show_columns">
            <template v-for="(col, col_ind) in d_ecosystemApplicationDatabaseConn.table_header">
              <b-form-checkbox :value="col_ind"> {{ col.label }} </b-form-checkbox>
            </template>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <b-button variant="warning" @click="d_ecoAppConfigColumn.show = false" style="margin-right: 10px;">kapat</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-if="d_terminalCode.show" :title="'Terminal Kodu Oluşturma Ekranı'" centered class="modal-success" v-model="d_terminalCode.show" @ok="d_terminalCode.show = false" ok-variant="success" hide-footer size="lg">
      <b-row>
        <b-col cols="12">
          <b-textarea v-model="d_terminalCode.text" style="width: 90%;" rows="10"></b-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="text-align: right;">
          <b-button variant="warning" @click="d_terminalCode.show = false" style="margin-right: 10px;">kapat</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import WamAdminService from '@/services/wamadmin';
//
var d_newTaskCommentKeyLastLocation = '';
// import WmanagerService from '@/services/wmanager';
// import { WmailApi } from '@/services/Wmail/wmailapi';
// import { WmanagerApi } from '@/services/Wmanager/WmanagerApi';
import { ClsSearch } from '@/services/public/search';
import {
  default as WisdomDataShow
} from '@/components/widgets/WisdomDataShow';
import Datepicker from "wisdom-vue-datepicker";
import {
  default as router
} from "@/router";
import moment from "moment";
import {
  default as Modal
} from "@/components/widgets/Modal";
import {
  default as WisdomDataModal
} from '@/components/widgets/WisdomDataModal';
import { ClsWdmrForever, ClsWdmrSave } from "@/services/public/wdm";
// import OrganizationService from '@/services/organization';
// import WconnectService from '@/services/wconnect';
import WdmService from '@/services/wdm';
import OptionService from '@/services/option';
import UserService from '@/services/users';
import GlobalService from '@/services/global';
import FileSaver from 'file-saver';
import FileTransferService from '@/services/file_transfer';
import { ClsWdmrManage } from "@/services/public/wdmr_manage";
import { mapGetters } from 'vuex';
import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  default as WTopMenu
} from '@/components/widgets/WTopMenu';
// import {
//   default as Modal
// } from '@/components/widgets/Modal';

export default {
  name: 'Application',
  props: {
    selected_organization_item: {
      type: Object,
      required: false
    },
    watch_task_list: {
      type: Object,
      required: false
    },
    organization_data: {
      type: Object,
      required: false
    },
    organization_id: {
      type: String,
      required: false
    },
    right_menu: {
      type: Boolean,
      required: false
    },
    organization_tree: {
      type: Boolean,
      required: false
    },
    left_tree_list_show: {
      type: Boolean,
      required: false
    },
    my_item_index_list: {
      type: Array,
      required: false
    },
    p_getSpecificTasks: {
      type: Object,
      required: false
    }
  },
  components: {
    WisdomDataShow,
    Modal,
    WTopMenu,
    WisdomDataModal,
    Datepicker
  },
  computed: {
    ...mapGetters({
      device: 'device'
    })
  },
  data () {
    return {
      d_terminalCode: {
        'text': '',
        'show': false
      },
      d_ecoAppConfigColumn: {
        'show_columns': [],
        'show': false
      },
      d_ecoAppConnCaptionUpdate: {
        'selected_options': [],
        'new_value': '',
        'caption_data': '',
        'show': false,
        'caption_index': ''
      },
      d_ecoAppConnCellUpdate: {
        'cell_data': '',
        'show': false,
        'row_index': '',
        'col_index': ''
      },
      d_appMergeSettings: {
        'config': { 'merge': 'no', 'label': 'Settings' },
        'friend': { 'merge': 'no', 'label': 'Friend' },
        'id': { 'merge': 'yes', 'label': 'Id & Value' },
        'location': { 'merge': 'yes', 'label': 'Location' },
        'requirement': { 'merge': 'yes', 'label': 'Requirement' },
        'statuscode': { 'merge': 'yes', 'label': 'Status Code' },
        'route': { 'merge': 'yes', 'label': 'Route' },
        'codepage': { 'merge': 'yes', 'label': 'Code Page' },
        'version': { 'merge': 'yes', 'label': 'Version' }
      },
      d_wdmrToken: { 'access_token': '', 'refresh_token': '' },
      d_managerApplicationBranches: {
        'show': false,
        'selected_index_from': '',
        'selected_index_to': '',
        'settings_order': ['config', 'friend', 'location', 'id', 'requirement', 'statuscode', 'route', 'codepage', 'version']
      },
      d_mergeManyApps: {
        'show_from_app_branch_model': false,
        'show_to_modal': false,
        'show_from_modal': false,
        'show': false,
        'selected_app_and_branch_from': '',
        'selected_app_and_branch_list_to': [],
        'settings_order': ['config', 'friend', 'location', 'id', 'requirement', 'statuscode', 'route', 'codepage', 'version']
      },
      d_managerServerApplications: { 'show': false, 'selected_index': '' },
      d_ecosystemApplicationDatabaseConn: {
        'count': '',
        'table': '',
        'table_body': '',
        'table_header': '',
        'view_mode': 'table',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_ecosystemData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_ecosystemServerData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_serverApplicationData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_selectedServerApplicationData: '',
      d_ecosystemServerUrlShowIframe: '',
      d_applicationListData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_selectedApplicationData: '',
      d_applicationBranchData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationConfigData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationFriendData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationRouteData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationCodepageData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationStatuscodeData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationIdData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationLocationData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationRequirementData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_applicationVersionData: {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      },
      d_WamAdminLayerData: require('@/services/Layers/wamadmin').wamadmin,
      //
      editor: ClassicEditor,
      editorConfig: {
        // placeholder: 'placeholder datası',
        toolbar: ["heading", "|", "bold", "italic", "link", "|", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "|", "mediaEmbed", "|", "insertTable", "tableColumn", "tableRow", "mergeTableCells", "|", "undo", "redo"]
          // toolbar: ["undo", "redo", "bold", "italic", "blockQuote", "ckfinder", "imageTextAlternative", "imageUpload", "heading", "imageStyle:full", "imageStyle:side", "link", "numberedList", "bulletedList", "mediaEmbed", "insertTable", "tableColumn", "tableRow", "mergeTableCells"]
          // config parameters: ['alignment', 'autosave', 'balloonToolbar', 'blockToolbar', 'ckfinder', 'cloudServices', 'codeBlock', 'exportPdf', 'exportWord', 'extraPlugins', 'fontBackgroundColor', 'fontColor', 'fontFamily', 'fontSize', 'heading', 'highlight', 'image', 'indentBlock', 'initialData', 'language', 'link', 'mediaEmbed', 'mention', 'placeholder', 'plugins', 'removePlugins', 'restrictedEditing', 'simpleUpload', 'table', 'title', 'toolbar', 'typing', 'wordCount']
          // https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editorconfig-EditorConfig.html
      },
      d_tagOperation: { 'show': false, 'operation_ind': '', 'all_tags': [], 'selected_tags': [] },
      d_showWdmrPreview: { 'show': false, 'url_show_iframe': '' },
      d_editingOperationIndex: '',
      rmdw: '',
      WDMR_LINKS: require('@/config/index').WDMR_LINKS,
      d_WmanagerLayerData: require('@/services/Wmanager/Layers').Layers,
      d_filter: { 'operation_no': '', 'search_text': '' },
      d_applyStatusOperation: { 'show': false, 'selected_index': '', 'task_ind': '' },
      d_allWdm22list: [],
      d_selectedWdmr17: '',
      d_selectedWdm22IdList: [],
      d_organizationWdm22List: [],
      change: '',
      d_selectedWdmr307: '',
      d_fullScreenOperationPage: false,
      d_fullScreenGeneral: false,
      d_selectedAnatomySchemaList: [],
      show_wisdom_data_modal: false,
      data_type: '',
      d_wdm22: {},
      wisdom_data: {},
      d_showWorkTimeModal: false,
      d_showWorkTimeEnd: true,
      d_selectedWorkItemIndex: '',
      d_taskWorkTime: {
        'day': 0,
        'hour': 0,
        'minute': 0,
        'second': 0
      },
      d_newWorkTime: { 'start': '', 'end': '', 'work_time_note': '' },
      d_workTimeEditMode: false,
      data_show_change: '0',
      d_showTaskPreviewData: '',
      d_scale: 1,
      rotate_degree: 0,
      document_show_data: { 'file': '', 'file_name': '' },
      show_image_show_modal: false,
      d_showTaskDocumentField: true,
      d_tmpFile: '',
      d_taskDocuments: {
        'show': false,
        'task': '',
        'task_ind': ''
      },
      d_filteredWhoCanSeeUsers: [],
      d_showTaskCommentsModal: false,
      d_allOrganizationUsers: {},
      d_selectedTaskForComment: {},
      d_newTaskComment: '',
      selected_task_index: '',
      d_organizationList: [],
      d_menuData: {},
      d_logResultPageData: { 'current': 1, 'perpage': 100 },
      d_searchText: '',
      d_isDataNewOrEdit: '',
      d_dataType: '',
      user: {},
      d_startingDate: '',
      d_endingDate: '',
      d_totalLogCount: 0,
      option_data: {},
      d_wdm17StateOptions: [],
      d_wdm17TaskTypeOptions: [],
      d_priorityList: [],
      d_menuFilterIndex: '',
      d_searchTaskListData: {
        'search_text': '',
        'organization_list': [],
        'active_user_index_list': [],
        'selected_layer': [],
        'username': '',
        'organization_id': 'uuid',
        'user_type': '', // this, all
        'priority': [], // drug_medical_equipment
        'task_type_list': [], // general, drug_medical_equipment, meeting etc.
        'state_list': [],
        'organization_type': 'all', // 'this' organization, 'all' organization
        'pagination': { 'start': 0, 'end': 50, 'current': 1, 'perpage': 50 },
        'tree_filter': []
      },
      d_pagination: {
        'start': 0,
        'end': 49,
        'current': 0,
        'perpage': 50
      },
      d_taskList: [],
      d_allTaskList: [],
      d_tmpTaskList: [],
      d_taskListCount: 1000000,
      d_selectedTab: 'app_details',
      d_wisdomData: {
        'operation_user_type': 'copy_to_everyone',
        'option_data': {},
        'show': false,
        'data_type': '',
        'layer_type': '',
        'wisdom_op': '',
        'url_iframe': ''
      },
    }
  },
  beforeCreate: function () {},
  created: function () {
    this.f_createMenuData();
    // this.f_prepareWdm17Data();
    this.user = JSON.parse(localStorage.getItem('user'));
    this.d_wdmrToken = JSON.parse(localStorage.getItem('wdmr_token'));
    this.f_getUserAppProjects();
  },
  mounted: function () {},
  destroyed () {},
  methods: {
    f_showCodeLink: function (url_show_iframe) {
      let msg = url_show_iframe;
      let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Code Page Link' };
      this.$store.commit('modal', modal_data);
      this.$store.commit('modal_show', true);
    },
    f_addThisColumnToShowList: function (caption_index) {
      if (this.d_ecoAppConfigColumn.show_columns.indexOf(caption_index) === -1) {
        this.d_ecoAppConfigColumn.show_columns.push(caption_index);
      }
      this.$forceUpdate();
    },
    f_calculateEcoAppConfigActiveRowCount: function () {
      this.d_ecosystemApplicationDatabaseConn.count = 0;
      let caption_row = this.d_ecosystemApplicationDatabaseConn.table_header;
      for (let row_index in this.d_ecosystemApplicationDatabaseConn.table_body) {
        let active_row = this.d_ecosystemApplicationDatabaseConn.table_body[parseInt(row_index)];
        let eligible_row = true;
        for (let caption_index in caption_row) {
          let caption_cell = caption_row[caption_index];
          let active_cell = active_row[caption_index];
          if (caption_cell.selected_options.length > 0) {
            if (caption_cell.selected_options.indexOf(active_cell.label) === -1) {
              eligible_row = false;
            }
          }
        }
        if (eligible_row) {
          this.d_ecosystemApplicationDatabaseConn.count += 1;
        }
      }
    },
    f_clearFilterColumn: function (caption_index) {
      this.d_ecosystemApplicationDatabaseConn.table_header[caption_index].selected_options = [];
      this.f_calculateEcoAppConfigActiveRowCount();
    },
    f_clearAllFilterColumns: function (caption_index) {
      for (let caption_index in this.d_ecosystemApplicationDatabaseConn.table_header) {
        this.d_ecosystemApplicationDatabaseConn.table_header[caption_index].selected_options = [];
      }
      this.f_calculateEcoAppConfigActiveRowCount();
    },
    f_filterRows: function (row_index) {
      let table_header = this.d_ecosystemApplicationDatabaseConn.table_header;
      let active_row = this.d_ecosystemApplicationDatabaseConn.table_body[row_index];
      for (let caption_index in table_header) {
        let caption_cell = table_header[caption_index];
        let active_cell = active_row[caption_index];
        if (caption_cell.selected_options.length > 0) {
          if (caption_cell.selected_options.indexOf(active_cell.label) === -1) {
            return false;
          }
        }
      }
      return true;
    },
    f_applyEcoAppDatabaseConnChanges: function () {
      if (this.$route.query.ecosystem_id !== undefined) {
        let data = {
          'table_header': this.d_ecosystemApplicationDatabaseConn.table_header,
          'table_body': [],
        };
        let col_length = this.d_ecosystemApplicationDatabaseConn.table_header.length;
        for (let row_index in this.d_ecosystemApplicationDatabaseConn.table_body) {
          let is_row_changed = false;
          for (let col_index = 0; col_index < col_length; col_index++) {
            let col_data = this.d_ecosystemApplicationDatabaseConn.table_header[col_index];
            let cell_data = this.d_ecosystemApplicationDatabaseConn.table_body[row_index][col_index];
            // console.log('col_data.editable: ', col_data.editable);
            if (col_data.editable === 'yes') {
              if (['textarea', 'text', 'integer', 'float'].indexOf(this.d_ecosystemApplicationDatabaseConn.table_header[col_index].type) !== -1) {
                if (cell_data.new_value !== cell_data.label) {
                  // console.log("cell_data ", cell_data);
                  is_row_changed = true;
                  break;
                }
              } else if (['select', 'radiogroup'].indexOf(this.d_ecosystemApplicationDatabaseConn.table_header[col_index].type) !== -1) {
                if (cell_data.new_value) {
                  if (cell_data.new_value.label !== cell_data.label) {
                    is_row_changed = true;
                    break;
                  }
                } else {
                  if (cell_data.label) {
                    is_row_changed = true;
                    break;
                  }
                }
              }
            }
          }
          if (is_row_changed) {
            data.table_body.push(this.d_ecosystemApplicationDatabaseConn.table_body[row_index]);
          }
        }
        if (data.table_body.length > 0) {
          console.log('data.table_body.length ', data.table_body.length);
          // console.log(data);
          // return;
          this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Değişiklikler uygulanıyor. Lütfen bekleyiniz.' } });
          let query = 'ecosystem_id=' + this.$route.query.ecosystem_id;
          WamAdminService.ecosystem_server_application_database_connection_change_apply(query, data)
            .then(resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
              if (resp.data.status_code === "8000") {
                this.d_ecosystemApplicationDatabaseConn.show = false;
                this.f_updateDatabaseConnectionStringForAllEcosystemApplications();
              } else {
                //
              }
              //
            }), resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            };
        } else {
          let msg = 'Değişiklik bulunan satır tespit edilmemiştir.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Ekosistem sunucu dal veritabanı ayarları düzenleme işlemleri hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }
      } else {
        let msg = 'Lütfen öncelikli olarak ekosistem seçimi yapınız.';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Ekosistem sunucu dal veritabanı ayarları düzenleme işlemleri hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      }
    },
    f_ecosystemServerApplicationBranchFriendUpdate: function () {
      if (this.$route.query.ecosystem_id !== undefined) {
        if (confirm('Ekosisteme ait uygulamalara ait arkadaş bilgilerini güncellemek istiyor musunuz ?')) {
          this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Ekosistem uygulamalarına ait arkadaşlar güncelleniyor. Lütfen bekleyiniz.' } });
          let query = 'ecosystem_id=' + this.$route.query.ecosystem_id;
          query += '&branch_type=production';
          WamAdminService.ecosystem_server_application_branch_friend_update(query)
            .then(resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
              if (resp.data.status_code === "8000") {
                console.log('Successfully completed');
              } else {
                //
              }
              //
            }), resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            };
        }
      } else {
        let msg = 'Lütfen öncelikli olarak ekosistem seçimi yapınız.';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Ekosistem sunucu dal veritabanı ayarları düzenleme işlemleri hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      }
    },
    f_applyFilterForColumns: function () {
      this.d_ecosystemApplicationDatabaseConn.table_header[this.d_ecoAppConnCaptionUpdate.caption_index].selected_options = this.d_ecoAppConnCaptionUpdate.selected_options;
      this.f_calculateEcoAppConfigActiveRowCount();
      this.d_ecoAppConnCaptionUpdate.show = false;
      this.$forceUpdate();
    },
    f_updateEcoAppConnAllCells: function () {
      if (confirm('Tüm hücreleri güncellemek istediğinize emin misiniz ?')) {
        let caption_row = this.d_ecosystemApplicationDatabaseConn.table_header;
        for (let row_index in this.d_ecosystemApplicationDatabaseConn.table_body) {
          let active_row = this.d_ecosystemApplicationDatabaseConn.table_body[row_index];
          let eligible_row = true;
          for (let caption_index in caption_row) {
            let caption_cell = caption_row[caption_index];
            let active_cell = active_row[caption_index];
            if (caption_cell.selected_options.length > 0) {
              if (caption_cell.selected_options.indexOf(active_cell.label) === -1) {
                eligible_row = false;
              }
            }
          }
          if (eligible_row) {
            this.d_ecosystemApplicationDatabaseConn.table_body[row_index][this.d_ecoAppConnCaptionUpdate.caption_index].new_value = this.d_ecoAppConnCaptionUpdate.new_value;
          }

        }
        this.d_ecoAppConnCaptionUpdate.show = false;
        this.$forceUpdate();
      }
    },
    f_ecoAppConnCaptionUpdate: function (caption_index, caption_data) {
      this.d_ecoAppConnCaptionUpdate.selected_options = caption_data.selected_options;
      this.d_ecoAppConnCaptionUpdate.new_value = '';
      this.d_ecoAppConnCaptionUpdate.caption_index = caption_index;
      this.d_ecoAppConnCaptionUpdate.caption_data = JSON.parse(JSON.stringify(caption_data));
      this.d_ecoAppConnCaptionUpdate.show = true;
    },
    f_updateEcoAppConnCell: function () {
      this.d_ecosystemApplicationDatabaseConn.table_body[this.d_ecoAppConnCellUpdate.row_index][this.d_ecoAppConnCellUpdate.col_index] = JSON.parse(JSON.stringify(this.d_ecoAppConnCellUpdate.cell_data));
      this.d_ecoAppConnCellUpdate.show = false;
      this.$forceUpdate();
    },
    f_ecoAppConnCellUpdate: function (row_index, col_index, col) {
      this.d_ecoAppConnCellUpdate.row_index = row_index
      this.d_ecoAppConnCellUpdate.col_index = col_index
      this.d_ecoAppConnCellUpdate.cell_data = JSON.parse(JSON.stringify(col));
      this.d_ecoAppConnCellUpdate.show = true;
    },
    f_calculateTableTdStyle: function (col) {
      let style = '';
      if (col.style) {
        style += col.style;
      }
      if (col.new_value !== '' && col.new_value !== undefined) {
        if (col.type === 'select') {
          if (col.new_value.label !== col.label) {
            style += '; background-color: #ffe7e7;';
          }
        } else if (col.type === 'textarea') {
          if (col.new_value !== col.label) {
            style += '; background-color: #ffe7e7;';
          }
        }
      }
      return style;
    },
    f_updateDatabaseConnectionStringForAllEcosystemApplications: function () {
      if (confirm('Ekosistem ayarlarını görüntülemek ve düzenlemek istediğinize emin misiniz ?')) {
        if (this.$route.query.ecosystem_id !== undefined) {
          this.d_ecosystemApplicationDatabaseConn.list = [];
          this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz yapılıyor. Lütfen bekleyiniz.' } });
          let query = 'ecosystem_id=' + this.$route.query.ecosystem_id;
          WamAdminService.get_ecosystem_server_application_database_connection_list(query)
            .then(resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
              if (resp.data.status_code === "8000") {
                console.log('Get ecosystem server app branch config details');
                this.d_ecosystemApplicationDatabaseConn.table_body = resp.data.table_body;
                this.d_ecosystemApplicationDatabaseConn.table_header = resp.data.table_header;
                this.d_ecosystemApplicationDatabaseConn.count = this.d_ecosystemApplicationDatabaseConn.table_body.length;
                // this.d_ecosystemApplicationDatabaseConn.list = resp.data.list;
                this.d_ecosystemApplicationDatabaseConn.show = true;
              } else {
                //
              }
              //
            }), resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            };
        } else {
          let msg = 'Lütfen öncelikli olarak ekosistem seçimi yapınız.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Ekosistem sunucu dal veritabanı ayarları düzenleme işlemleri hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }
      }
    },
    f_openMergeManyAppsModal: function () {
      this.d_mergeManyApps.settings = JSON.parse(JSON.stringify(this.d_appMergeSettings));
      this.d_mergeManyApps.selected_app_and_branch_from = '';
      this.d_mergeManyApps.selected_app_and_branch_list_to = [];
      this.d_mergeManyApps.show = true;
    },
    f_selectAppFrom: function (app) {
      let layer_type = 'system_users_appprojects_appbranchs';
      let wdmr_data = '0';
      let query = 'wdmr_data=' + wdmr_data + '&layer_type=' + layer_type;
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(app.id);
      let data = {
        'w_id_list': w_id_list
      };
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz yapılıyor. Lütfen bekleyiniz.' } });
      WamAdminService.layer_wdmr_list(query, data)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.list) {
            this.d_mergeManyApps.selected_app_and_branch_from = app;
            this.d_mergeManyApps.selected_app_and_branch_from.branch_list = resp.data.list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectAppTo: function (app) {
      let det = false;
      for (let i in this.d_mergeManyApps.selected_app_and_branch_list_to) {
        if (this.d_mergeManyApps.selected_app_and_branch_list_to[i].id === app.id) {
          det = true;
          break;
        }
      }
      if (det) {
        let msg = 'Bu uygulama zaten eklidir';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Hedef Uygulama Listesi Hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      } else {
        let layer_type = 'system_users_appprojects_appbranchs';
        let wdmr_data = '0';
        let query = 'wdmr_data=' + wdmr_data + '&layer_type=' + layer_type;
        let w_id_list = [];
        w_id_list.push(this.user.id);
        w_id_list.push(app.id);
        let data = {
          'w_id_list': w_id_list
        };
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz yapılıyor. Lütfen bekleyiniz.' } });
        WamAdminService.layer_wdmr_list(query, data)
          .then(resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            if (resp.data.status_code === "8000" && resp.data.list) {
              this.d_mergeManyApps.selected_app_and_branch_list_to.push(app);
              let end_index = this.d_mergeManyApps.selected_app_and_branch_list_to.length - 1;
              this.d_mergeManyApps.selected_app_and_branch_list_to[end_index].branch_list = resp.data.list;
            } else {
              //
            }
            //
          }), resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          };
      }
    },
    f_selectAppBranchFrom: function (branch_data) {
      this.d_mergeManyApps.selected_app_and_branch_from.branch = branch_data;
      this.$forceUpdate();
    },
    f_selectToAppBranch: function (to_app_ind, branch) {
      let branch_same = this.d_mergeManyApps.selected_app_and_branch_from.branch.id === branch.id;
      let app_same = this.d_mergeManyApps.selected_app_and_branch_from.id === this.d_mergeManyApps.selected_app_and_branch_list_to[to_app_ind].id;
      if (app_same && branch_same) {
        let msg = 'Bu uygulama dalı kaynak uygulama dalında seçilidir.';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Hedef Uygulama Dalı Hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      } else {
        this.d_mergeManyApps.selected_app_and_branch_list_to[to_app_ind].selected_branch = JSON.parse(JSON.stringify(branch));
        this.$forceUpdate();
      }
    },
    f_deleteToApp: function (to_app_ind) {
      this.d_mergeManyApps.selected_app_and_branch_list_to.splice(to_app_ind, 1);
      this.$forceUpdate();
    },
    f_selectApplicationForMergingModal: function () {
      this.d_mergeManyApps.show_from_modal = true;
    },
    f_selectToApplicationForMergingModal: function () {
      this.d_mergeManyApps.show_to_modal = true;
    },
    f_selectApplicationBranchForMergingModal: function () {
      this.d_mergeManyApps.show_from_app_branch_model = true;
    },
    f_updateMergeManyOption: function (x) {
      if (this.d_mergeManyApps.settings[x].merge === 'yes') {
        this.d_mergeManyApps.settings[x].merge = 'no';
      } else {
        this.d_mergeManyApps.settings[x].merge = 'yes';
      }
      this.$forceUpdate();
    },
    f_updateMergeOption: function (x) {
      if (this.d_managerApplicationBranches.settings[x].merge === 'yes') {
        this.d_managerApplicationBranches.settings[x].merge = 'no';
      } else {
        this.d_managerApplicationBranches.settings[x].merge = 'yes';
      }
      this.$forceUpdate();
    },
    f_mergeBranches: function () {
      if (this.d_managerApplicationBranches.selected_index_to !== '' && this.d_managerApplicationBranches.selected_index_from !== '') {
        if (this.d_managerApplicationBranches.selected_index_to !== this.d_managerApplicationBranches.selected_index_from) {
          let from_branch_index = this.d_managerApplicationBranches.selected_index_from;
          let to_branch_index = this.d_managerApplicationBranches.selected_index_to;
          let query = '';
          query += 'from=' + this.d_applicationBranchData.list[from_branch_index].id;
          query += '&to=' + this.d_applicationBranchData.list[to_branch_index].id;
          query += '&app_id=' + this.d_selectedApplicationData.id;
          let data = {
            'settings': this.d_managerApplicationBranches.settings
          };
          this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Birleştirme işlemi başlatılmıştır. Lütfen bekleyiniz.' } });
          WamAdminService.application_branch_merge(query, data)
            .then(resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
              console.log(resp.data);
              if (resp.data.status_code === "8000") {
                // console.log('...');
                let msg = 'Successfully merged.';
                let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Application branch merge' };
                this.$store.commit('modal', modal_data);
                this.$store.commit('modal_show', true);
              } else {
                let msg = JSON.stringify(resp);
                let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
                this.$store.commit('modal', modal_data);
                this.$store.commit('modal_show', true);
              }
            }), resp => {
              this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            };
        } else {
          let msg = 'Verilerin alınacağı dalı (from) ve hedef dalı (to) farklı seçiniz. ';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Dal güncelleme işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }
      } else {
        let msg = 'Verilerin alınacağı dalı (from) ve hedef dalı (to) seçiniz. ';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Dal güncelleme işlemi hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      }
    },
    f_mergeMultiApps: function () {
      if (this.d_mergeManyApps.selected_app_and_branch_from && this.d_mergeManyApps.selected_app_and_branch_from.branch) {
        if (this.d_mergeManyApps.selected_app_and_branch_list_to.length > 0) {
          let not_eligible_det = false;
          for (let i in this.d_mergeManyApps.selected_app_and_branch_list_to) {
            if (this.d_mergeManyApps.selected_app_and_branch_list_to[i].selected_branch && this.d_mergeManyApps.selected_app_and_branch_list_to[i].selected_branch.id) {
              //
            } else {
              not_eligible_det = true;
              break
            }
          }
          if (not_eligible_det) {
            let msg = 'Hedef uygulama dallarını seçiniz.';
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Uygulama dal güncelleme işlemi hakkında' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          } else {
            let data = {
              'settings': this.d_mergeManyApps.settings,
              'selected_app_and_branch_from': this.d_mergeManyApps.selected_app_and_branch_from,
              'selected_app_and_branch_list_to': this.d_mergeManyApps.selected_app_and_branch_list_to
            };
            this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Birleştirme işlemi başlatılmıştır. Lütfen bekleyiniz.' } });
            WamAdminService.application_branch_merge_multi(data)
              .then(resp => {
                this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
                console.log(resp.data);
                if (resp.data.status_code === "8000") {
                  console.log('...');
                } else {
                  let msg = JSON.stringify(resp);
                  let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
                  this.$store.commit('modal', modal_data);
                  this.$store.commit('modal_show', true);
                }
              }), resp => {
                this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
              };
          }
        } else {
          let msg = 'Hedef uygulama ve dallarını seçiniz.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Uygulama dal güncelleme işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }
      } else {
        let msg = 'Kaynak uygulama ve dalını seçiniz. ';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Uygulama dal güncelleme işlemi hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      }
    },
    f_addApplicationToServer: function (x_ind) {
      let is_app_eligible = true;
      let application_data = this.d_applicationListData.list[this.d_managerServerApplications.selected_index];
      if (this.d_serverApplicationData.list.length > 0) {
        for (let i in this.d_serverApplicationData.list) {
          if (application_data.id === this.d_serverApplicationData.list[i].id) {
            // Here it means this app is already added to server app list.
            is_app_eligible = false;
            break
          }
        }
      }
      if (is_app_eligible && this.d_ecosystemServerData.data.id) {
        let query = 'app_id=' + application_data.id + '&server_id=' + this.d_ecosystemServerData.data.id;
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama sunucuya ekleniyor. Lütfen bekleyiniz.' } });
        WamAdminService.ecosystem_application_server_add(query)
          .then(resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            console.log(resp.data);
            if (resp.data.status_code === "8000") {
              let w_id_list = [];
              w_id_list.push(resp.data.data.id);
              let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
            } else {
              let msg = JSON.stringify(resp);
              let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
              this.$store.commit('modal', modal_data);
              this.$store.commit('modal_show', true);
            }
            //
          }), resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          };
      }
    },
    f_manageServerApplications: function () {
      this.d_managerServerApplications.show = true;
    },
    f_getPullTerminalCode: function (type, os_type) {
      let ecosystem_id = this.d_ecosystemData.list[this.d_ecosystemData.selected_index].id;
      let application_id = this.d_serverApplicationData.list[this.d_serverApplicationData.selected_index].id;
      let server_id = this.d_ecosystemServerData.list[this.d_ecosystemServerData.selected_index].id;
      let branch_type = this.d_applicationBranchData.data.data.general.branch_type.val.value;
      if (os_type === 'linux') {
        if (type === 'this_application_this_branch_with_all_info_with_password') {
          this.d_terminalCode.text = 'sudo python /opt/WamServer/wamserver-app/src/server.py ecosystem process=pull ecosystem=' + ecosystem_id + ' server=' + server_id + ' user=' + this.user.username + ' user_id=' + this.user.id + ' password=******* app=' + application_id + ' branch=' + branch_type + ' path=/opt/WamServer/ecosystem';
        } else if (type === 'this_application_this_branch_with_all_info_without_password') {
          this.d_terminalCode.text = 'sudo python /opt/WamServer/wamserver-app/src/server.py ecosystem process=pull ecosystem=' + ecosystem_id + ' server=' + server_id + ' user=' + this.user.username + ' user_id=' + this.user.id + ' app=' + application_id + ' branch=' + branch_type + ' path=/opt/WamServer/ecosystem';
        } else if (type === 'this_application_this_branch_with_app_and_branch_type') {
          this.d_terminalCode.text = 'sudo python /opt/WamServer/wamserver-app/src/server.py ecosystem process=pull app=' + application_id + ' branch=' + branch_type + ' path=/opt/WamServer/ecosystem';
        }
      } else if (os_type === 'windows') {
        if (type === 'this_application_this_branch_with_all_info_with_password') {
          this.d_terminalCode.text = 'python c://projects/wamserver-app/src/server.py ecosystem process=pull ecosystem=' + ecosystem_id + ' server=' + server_id + ' user=' + this.user.username + ' user_id=' + this.user.id + ' password=******* app=' + application_id + ' branch=' + branch_type + ' path=c://projects/ecosystem';
        } else if (type === 'this_application_this_branch_with_all_info_without_password') {
          this.d_terminalCode.text = 'python c://projects/wamserver-app/src/server.py ecosystem process=pull ecosystem=' + ecosystem_id + ' server=' + server_id + ' user=' + this.user.username + ' user_id=' + this.user.id + ' app=' + application_id + ' branch=' + branch_type + ' path=c://projects/ecosystem';
        } else if (type === 'this_application_this_branch_with_app_and_branch_type') {
          this.d_terminalCode.text = 'python c://projects/wamserver-app/src/server.py ecosystem process=pull app=' + application_id + ' branch=' + branch_type + ' path=c://projects/ecosystem';
        }
      }
      this.d_terminalCode.show = true;
    },
    f_selectForServer: function (x_ind) {
      this.d_managerServerApplications.selected_index = x_ind;
      this.$forceUpdate()
    },
    f_manageApplicationBranchesForMerging: function () {
      this.d_managerApplicationBranches.settings = JSON.parse(JSON.stringify(this.d_appMergeSettings));
      this.d_managerApplicationBranches.selected_index_to = '';
      this.d_managerApplicationBranches.selected_index_from = '';
      this.d_managerApplicationBranches.show = true;
    },
    f_selectApplicationBranchForMerging: function (x_ind, type) {
      this.d_managerApplicationBranches[type] = x_ind;
      this.$forceUpdate()
    },
    f_completeWdmrSave: function () {
      let query = 'layer_type=' + this.d_wisdomData.layer_type;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&app_id=' + this.d_selectedApplicationData.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.update_layer_type(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000") {
            this.d_wisdomData.show = false;
          } else {
            let msg = JSON.stringify(resp);
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_updateCodePagesFromConfig: function (layer_type) {
      let query = 'layer_type=' + layer_type;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&app_id=' + this.d_selectedApplicationData.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.update_layer_type(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000") {
            let msg = 'Successfully completed';
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Config to code pages process' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          } else {
            let msg = JSON.stringify(resp);
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_editSelectedApplicationWdmr: function () {
      let layer_type = 'system_users_appprojects';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedEcosystemWdmr: function () {
      let layer_type = 'system_users_ecosystems';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_ecosystemData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedVersionWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appversions';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationVersionData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedRequirementWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_apprequirements';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationRequirementData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedCodePagesWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appcodepages';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationCodepageData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedLocationWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_applocations';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationLocationData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedIdDataWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appids';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationIdData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedStatuscodeWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appstatuscodes';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      if (this.d_applicationStatuscodeData.data && this.d_applicationStatuscodeData.data.id) {
        w_id_list.push(this.d_applicationStatuscodeData.data.id);
        let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
        this.d_wisdomData = {
          'w_id_list': w_id_list,
          'show': true,
          'layer_type': layer_type,
          'wisdom_op': 'edit',
          'url_iframe': url_show_iframe
        };
      } else {
        let wdmr = {
          'label': 'New Status Codes',
          'data': {
            'general': {
              'name': { 'val': 'New Status Codes' }
            }
          }
        };
        this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
      }
    },
    f_editSelectedRouteWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_approutes';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationRouteData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_editSelectedConfigWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appconfigs';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      if (this.d_applicationConfigData.data && this.d_applicationConfigData.data.id) {
        w_id_list.push(this.d_applicationConfigData.data.id);
        let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
        this.d_wisdomData = {
          'w_id_list': w_id_list,
          'show': true,
          'layer_type': layer_type,
          'wisdom_op': 'edit',
          'url_iframe': url_show_iframe
        };
      } else {
        let wdmr = {
          'label': 'New Application Config',
          'data': {
            'general': {
              'name': { 'val': 'New Application Config' }
            }
          }
        };
        this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
      }
    },
    f_editSelectedFriendWdmr: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appfriends';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      w_id_list.push(this.d_applicationFriendData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_addNewFriendToApplication: function () {
      let wdmr = {
        'label': 'New Friend',
        'data': {
          'general': {
            'friend_name': { 'val': 'New Friend' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_appfriends';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewFriendToApplicationByCloning: function () {
      let wdmr = {
        'label': this.d_applicationFriendData.data.label,
        'data': JSON.parse(JSON.stringify(this.d_applicationFriendData.data.data))
      };
      let layer_type = 'system_users_appprojects_appbranchs_appfriends';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewRouteToApplication: function () {
      let wdmr = {
        'label': 'New Url',
        'data': {
          'general': {
            'url': { 'val': 'New Url' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_approutes';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewIdDataToApplication: function () {
      let wdmr = {
        'label': 'New Id',
        'data': {
          'general': {
            'id_name': { 'val': 'New Id' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_appids';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewCodepageToApplication: function () {
      let wdmr = {
        'label': 'New Code Page',
        'data': {
          'general': {
            'name': { 'val': 'New Code Page' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_appcodepages';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewLocationToApplication: function () {
      let wdmr = {
        'label': 'New Location',
        'data': {
          'general': {
            'location_name': { 'val': 'New Location' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_applocations';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewRequirementToApplication: function () {
      let wdmr = {
        'label': 'New Requirement',
        'data': {
          'general': {
            'name': { 'val': 'New Requirement' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_apprequirements';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewVersionToApplication: function () {
      let wdmr = {
        'label': 'New Version',
        'data': {
          'general': {
            'version': { 'val': 'New Version' }
          }
        }
      };
      let layer_type = 'system_users_appprojects_appbranchs_appversions';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_selectedApplicationData.id);
      w_id_list.push(this.d_applicationBranchData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_addNewServerToEcosystem: function () {
      let wdmr = {
        'label': 'New Server',
        'data': {
          'general': {
            'name': { 'val': 'New Server' }
          }
        }
      };
      let layer_type = 'system_users_ecosystems_servers';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_ecosystemData.data.id);
      this.f_layerWdmrSaveByWdmrIdList(layer_type, w_id_list, wdmr);
    },
    f_layerWdmrSaveByWdmrIdList: function (layer_type, w_id_list, wdmr) {
      if (confirm('İşlemi gerçekleştirmek istediğinize emin misiniz ?')) {
        let query = 'layer_type=' + layer_type;
        let data = {
          'w_id_list': w_id_list,
          'wdmr': wdmr
        };
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz gerçekleştiriliyor. Lütfen bekleyiniz.' } });
        WamAdminService.layer_wdmr_save_by_wdmr_id_list(query, data)
          .then(resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            if (resp.data.status_code === "8000" && resp.data.data && resp.data.data.id) {
              w_id_list.push(resp.data.data.id);
              let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
              this.d_wisdomData = {
                'w_id_list': w_id_list,
                'show': true,
                'layer_type': layer_type,
                'wisdom_op': 'edit',
                'url_iframe': url_show_iframe
              };
            } else {
              let msg = JSON.stringify(resp);
              let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
              this.$store.commit('modal', modal_data);
              this.$store.commit('modal_show', true);
            }
            //
          }), resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          };
      }
    },
    f_trashFriend: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appfriends';
      let id_list = [this.d_applicationFriendData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashApplicationId: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appids';
      let id_list = [this.d_applicationIdData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashLocation: function () {
      let layer_type = 'system_users_appprojects_appbranchs_applocations';
      let id_list = [this.d_applicationLocationData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashRequirement: function () {
      let layer_type = 'system_users_appprojects_appbranchs_apprequirements';
      let id_list = [this.d_applicationRequirementData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashVersion: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appversions';
      let id_list = [this.d_applicationVersionData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashCodePage: function () {
      let layer_type = 'system_users_appprojects_appbranchs_appcodepages';
      let id_list = [this.d_applicationCodepageData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_trashApplicationRoute: function () {
      let layer_type = 'system_users_appprojects_appbranchs_approutes';
      let id_list = [this.d_applicationRouteData.data.id];
      this.f_layerWdmrTrash(layer_type, id_list)
    },
    f_layerWdmrTrash: function (layer_type, id_list) {
      /* id_list = ['1,56,78'] */
      let query = 'layer_type=' + layer_type;
      query += '&id_list=' + id_list;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.layer_wdmr_trash(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000") {
            console.log(resp.data);
          } else {
            let msg = JSON.stringify(resp);
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Kayıt işlemi hakkında' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_editSelectedEcosystemServerWdmr: function () {
      let layer_type = 'system_users_ecosystems_servers';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_ecosystemData.data.id);
      w_id_list.push(this.d_ecosystemServerData.data.id);
      let url_show_iframe = this.f_createUrlIframeRecord(layer_type, w_id_list);
      this.d_wisdomData = {
        'w_id_list': w_id_list,
        'show': true,
        'layer_type': layer_type,
        'wisdom_op': 'edit',
        'url_iframe': url_show_iframe
      };
    },
    f_getUserAppProjects: function () {
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Kullanıcı uygulama projeleri getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      WamAdminService.application_project_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.application_list) {
            this.d_applicationListData.list = resp.data.application_list;
            if (this.$route.query && this.$route.query.application_id !== undefined) {
              for (let i in this.d_applicationListData.list) {
                // console.log(this.d_applicationListData.list[i].id);
                if (this.d_applicationListData.list[i].id === this.$route.query.application_id) {
                  this.f_selectApplication(parseInt(i));
                  break
                }
              }
            }
            this.f_getUserEcosystems();
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getUserEcosystems: function () {
      console.log('f_getUserEcosystems');
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Kullanıcı uygulama ekosistemleri getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      WamAdminService.ecosystem_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.ecosystem_list) {
            this.d_ecosystemData.list = resp.data.ecosystem_list;
            if (this.$route.query && this.$route.query.ecosystem_id !== undefined) {
              for (let i in this.d_ecosystemData.list) {
                // console.log(this.d_ecosystemData.list[i].id);
                if (this.d_ecosystemData.list[i].id === this.$route.query.ecosystem_id) {
                  this.f_selectEcosystem(parseInt(i));
                  break
                }
              }
            }
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_cancelAllSelections: function () {
      this.d_selectedTab = 'app_details';
      this.d_ecosystemData.data = '';
      this.d_ecosystemData.selected_index = '';
      this.d_ecosystemServerData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_serverApplicationData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_selectedServerApplicationData = '';
      this.d_applicationBranchData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationConfigData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationFriendData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationRouteData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationCodepageData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationStatuscodeData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationIdData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationLocationData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationRequirementData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationVersionData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.$forceUpdate();
    },
    f_cancelApplicationSelectedDetails: function () {
      this.d_selectedTab = 'branch_list';
      this.d_applicationBranchData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationConfigData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationFriendData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationRouteData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationCodepageData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationStatuscodeData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationIdData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationLocationData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationRequirementData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.d_applicationVersionData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      this.$forceUpdate();
    },
    f_selectApplication: function (x_ind) {
      this.f_cancelApplicationSelectedDetails();
      let application_id = this.d_applicationListData.list[x_ind].id;
      this.d_applicationListData.selected_index = x_ind;
      if (!this.$route.query === undefined || (this.$route.query !== undefined && (this.$route.query.application_id === undefined || (this.$route.query.application_id !== application_id)))) {
        let route_data = {
          'query': {
            'application_id': application_id
          }
        };
        this.$router.push(route_data);
      }
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama projesi getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      WamAdminService.application_project_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.application_data) {
            this.d_selectedApplicationData = resp.data.application_data;
            let layer_type = 'system_users_appprojects';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            this.f_updateUrlIframe(this.d_applicationListData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
            this.f_getAppBranchList(application_id);
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_createUrlIframeShow: function (layer_type, w_id_list) {
      let url_iframe_show = this.WDMR_LINKS['show'] + 'layer_id=' + this.d_WamAdminLayerData[layer_type].layer_id + '&w_id_list=' + w_id_list.join(',') + '&wisdom=' + this.d_wdmrToken.access_token + '&modsiw=' + this.d_wdmrToken.refresh_token;
      return url_iframe_show;
    },
    f_createUrlIframeRecord: function (layer_type, w_id_list) {
      let url_iframe_record = this.WDMR_LINKS['record'] + 'layer_id=' + this.d_WamAdminLayerData[layer_type].layer_id + '&w_id_list=' + w_id_list.join(',') + '&wisdom=' + this.d_wdmrToken.access_token + '&modsiw=' + this.d_wdmrToken.refresh_token;
      return url_iframe_record;
    },
    f_updateRouteQuery: function (update_query_args) {
      let new_route_data = {
        'query': JSON.parse(JSON.stringify(this.$route.query))
      };
      for (let i in update_query_args) {
        new_route_data.query[i] = update_query_args[i];
      }
      if (JSON.stringify(new_route_data.query) !== JSON.stringify(this.$route.query)) {
        this.$router.push(new_route_data);
      }
    },
    f_selectEcosystemServer: function (x_ind) {
      let server_id = this.d_ecosystemServerData.list[x_ind].id;
      this.f_updateRouteQuery({ 'server_id': server_id });
      this.d_ecosystemServerData.selected_index = x_ind;
      let layer_type = 'system_users_ecosystems_servers';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_ecosystemData.data.id);
      w_id_list.push(server_id);
      this.f_updateUrlIframe(this.d_ecosystemServerData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
      this.f_getLayerWdmrList(layer_type, w_id_list, '1', true);
      layer_type = 'system_users_ecosystems_servers_applications';
      this.d_serverApplicationData.url_show_iframe = '';
      this.f_getLayerWdmrList(layer_type, w_id_list);
    },
    f_updateUrlIframe: function (obj, url_iframe_var, new_url) {
      obj[url_iframe_var] = '';
      setTimeout(function () {
        obj[url_iframe_var] = new_url;
      }.bind(this), 1000)
    },
    f_selectServerApplication: function (x_ind) {
      let application_id = this.d_serverApplicationData.list[x_ind].id;
      this.f_updateRouteQuery({ 'application_id': application_id });
      this.d_serverApplicationData.selected_index = x_ind;
      let layer_type = 'system_users_ecosystems_servers_applications';
      let w_id_list = [];
      w_id_list.push(this.user.id);
      w_id_list.push(this.d_ecosystemData.data.id);
      w_id_list.push(this.d_ecosystemServerData.data.id);
      w_id_list.push(application_id);
      this.f_updateUrlIframe(this.d_serverApplicationData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
      if (this.d_selectedApplicationData && this.d_selectedApplicationData.id === application_id) {
        //
      } else {
        if (this.d_applicationListData.list.length === 0) {
          this.f_getUserAppProjects();
        } else {
          for (let i in this.d_applicationListData.list) {
            if (this.d_applicationListData.list[i].id === application_id) {
              this.f_selectApplication(parseInt(i));
              break;
            }
          }
        }
      }
    },
    f_selectEcosystem: function (x_ind) {
      let ecosystem_id = this.d_ecosystemData.list[x_ind].id;
      this.d_ecosystemData.selected_index = x_ind;
      this.f_updateRouteQuery({ 'ecosystem_id': ecosystem_id });
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Ekosistem verisi getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&ecosystem_id=' + ecosystem_id;
      WamAdminService.ecosystem_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.data) {
            this.d_ecosystemData.data = resp.data.data;
            let layer_type = 'system_users_ecosystems';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_ecosystemData.data.id);
            this.f_updateUrlIframe(this.d_ecosystemData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
            this.d_selectedTab = 'ecosystem_details';
            this.f_getLayerWdmrList('system_users_ecosystems_servers', w_id_list);
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getLayerWdmrList: function (layer_type, w_id_list, wdmr_data = '0', select_wdmr = false) {
      let query = 'wdmr_data=' + wdmr_data + '&layer_type=' + layer_type;
      let data = {
        'w_id_list': w_id_list
      };
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'İşleminiz yapılıyor. Lütfen bekleyiniz.' } });
      WamAdminService.layer_wdmr_list(query, data)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.list) {
            if (layer_type === 'system_users_ecosystems_servers') {
              if (select_wdmr) {
                if (resp.data.list.length > 0) {
                  this.d_ecosystemServerData.data = resp.data.list[0].wdmr;
                }
              } else {
                this.d_ecosystemServerData.list = resp.data.list;
              }
            } else if (layer_type === 'system_users_ecosystems_servers_applications') {
              if (select_wdmr) {
                if (resp.data.list.length > 0) {
                  this.d_selectedServerApplicationData = resp.data.list[0].wdmr;
                }
              } else {
                this.d_serverApplicationData.list = resp.data.list;
              }
            }
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppBranchList: function (application_id) {
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama dalları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      WamAdminService.application_project_branch_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.branch_list) {
            this.d_applicationBranchData.list = resp.data.branch_list;
            if (this.$route.query && this.$route.query.branch_id !== undefined) {
              for (let i in this.d_applicationBranchData.list) {
                // console.log(this.d_applicationBranchData.list[i].id);
                if (this.d_applicationBranchData.list[i].id === this.$route.query.branch_id) {
                  this.f_selectApplicationBranch(parseInt(i));
                  break
                }
              }
            }
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationBranch: function (x_ind) {
      this.d_applicationBranchData.url_show_iframe = '';
      let application_id = this.$route.query.application_id;
      let branch_id = this.d_applicationBranchData.list[x_ind].id;
      this.f_updateRouteQuery({ 'branch_id': branch_id });
      this.d_applicationBranchData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama dal detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + branch_id;
      WamAdminService.application_project_branch_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.branch_data) {
            this.d_applicationBranchData.data = resp.data.branch_data;
            let layer_type = 'system_users_appprojects_appbranchs';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            this.f_updateUrlIframe(this.d_applicationBranchData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppFriendList: function () {
      this.d_applicationFriendData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama arkadaşları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_friend_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.friend_list) {
            this.d_applicationFriendData.list = resp.data.friend_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationFriend: function (x_ind) {
      this.d_applicationFriendData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let friend_id = this.d_applicationFriendData.list[x_ind].id;
      this.d_applicationFriendData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama arkadaş detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&friend_id=' + friend_id;
      WamAdminService.application_project_friend_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.friend_data) {
            this.d_applicationFriendData.data = resp.data.friend_data;
            let layer_type = 'system_users_appprojects_appbranchs_appfriends';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationFriendData.data.id);
            this.f_updateUrlIframe(this.d_applicationFriendData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppConfigList: function () {
      this.d_applicationConfigData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama ayarları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_config_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.config_list) {
            this.d_applicationConfigData.list = resp.data.config_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationConfig: function (x_ind) {
      this.d_applicationConfigData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let config_id = this.d_applicationConfigData.list[x_ind].id;
      this.d_applicationConfigData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama ayar detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&config_id=' + config_id;
      WamAdminService.application_project_config_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.config_data) {
            this.d_applicationConfigData.data = resp.data.config_data;
            let layer_type = 'system_users_appprojects_appbranchs_appconfigs';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationConfigData.data.id);
            this.f_updateUrlIframe(this.d_applicationConfigData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppRouteList: function () {
      this.d_applicationRouteData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yolları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_route_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.route_list) {
            this.d_applicationRouteData.list = resp.data.route_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationRoute: function (x_ind) {
      this.d_applicationRouteData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let route_id = this.d_applicationRouteData.list[x_ind].id;
      this.d_applicationRouteData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yol detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&route_id=' + route_id;
      WamAdminService.application_project_route_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.route_data) {
            this.d_applicationRouteData.data = resp.data.route_data;
            let layer_type = 'system_users_appprojects_appbranchs_approutes';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationRouteData.data.id);
            this.f_updateUrlIframe(this.d_applicationRouteData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppCodepageList: function () {
      this.d_applicationCodepageData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yolları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_codepage_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.codepage_list) {
            this.d_applicationCodepageData.list = resp.data.codepage_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationCodepage: function (x_ind) {
      this.d_applicationCodepageData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let codepage_id = this.d_applicationCodepageData.list[x_ind].id;
      this.d_applicationCodepageData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yol detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&codepage_id=' + codepage_id;
      WamAdminService.application_project_codepage_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.codepage_data) {
            this.d_applicationCodepageData.data = resp.data.codepage_data;
            let layer_type = 'system_users_appprojects_appbranchs_appcodepages';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationCodepageData.data.id);
            this.f_updateUrlIframe(this.d_applicationCodepageData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppStatuscodeList: function () {
      this.d_applicationStatuscodeData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama durum kodları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_statuscode_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.statuscode_list) {
            this.d_applicationStatuscodeData.list = resp.data.statuscode_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationStatuscode: function (x_ind) {
      this.d_applicationStatuscodeData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let statuscode_id = this.d_applicationStatuscodeData.list[x_ind].id;
      this.d_applicationStatuscodeData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama durum kodu detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&statuscode_id=' + statuscode_id;
      WamAdminService.application_project_statuscode_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.statuscode_data) {
            this.d_applicationStatuscodeData.data = resp.data.statuscode_data;
            let layer_type = 'system_users_appprojects_appbranchs_appstatuscodes';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationStatuscodeData.data.id);
            this.f_updateUrlIframe(this.d_applicationStatuscodeData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppIdList: function () {
      this.d_applicationIdData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama id verileri getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_id_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.id_list) {
            this.d_applicationIdData.list = resp.data.id_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationId: function (x_ind) {
      this.d_applicationIdData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let id_id = this.d_applicationIdData.list[x_ind].id;
      this.d_applicationIdData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama id veri detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&id_id=' + id_id;
      WamAdminService.application_project_id_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.id_data) {
            this.d_applicationIdData.data = resp.data.id_data;
            let layer_type = 'system_users_appprojects_appbranchs_appids';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationIdData.data.id);
            this.f_updateUrlIframe(this.d_applicationIdData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppLocationList: function () {
      this.d_applicationLocationData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yolları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_location_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.location_list) {
            this.d_applicationLocationData.list = resp.data.location_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationLocation: function (x_ind) {
      this.d_applicationLocationData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let location_id = this.d_applicationLocationData.list[x_ind].id;
      this.d_applicationLocationData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama yol detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&location_id=' + location_id;
      WamAdminService.application_project_location_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.location_data) {
            this.d_applicationLocationData.data = resp.data.location_data;
            let layer_type = 'system_users_appprojects_appbranchs_applocations';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationLocationData.data.id);
            this.f_updateUrlIframe(this.d_applicationLocationData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppRequirementList: function () {
      this.d_applicationRequirementData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama gereklilikleri getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_requirement_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.requirement_list) {
            this.d_applicationRequirementData.list = resp.data.requirement_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationRequirement: function (x_ind) {
      this.d_applicationRequirementData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let requirement_id = this.d_applicationRequirementData.list[x_ind].id;
      this.d_applicationRequirementData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama gereklilik detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&requirement_id=' + requirement_id;
      WamAdminService.application_project_requirement_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.requirement_data) {
            this.d_applicationRequirementData.data = resp.data.requirement_data;
            let layer_type = 'system_users_appprojects_appbranchs_apprequirements';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationRequirementData.data.id);
            this.f_updateUrlIframe(this.d_applicationRequirementData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_getAppVersionList: function () {
      this.d_applicationVersionData = {
        'url_show_iframe': '',
        'data': '',
        'show': false,
        'list': [],
        'selected_index': ''
      };
      let application_id = this.d_selectedApplicationData.id;
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama arkadaşları getiriliyor. Lütfen bekleyiniz.' } });
      WamAdminService.application_project_version_list(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.version_list) {
            this.d_applicationVersionData.list = resp.data.version_list;
          } else {
            //
          }
          //
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_selectApplicationVersion: function (x_ind) {
      this.d_applicationVersionData.url_show_iframe = '';
      let application_id = this.d_selectedApplicationData.id;
      let version_id = this.d_applicationVersionData.list[x_ind].id;
      this.d_applicationVersionData.selected_index = x_ind;
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Uygulama arkadaş detayları getiriliyor. Lütfen bekleyiniz.' } });
      let query = 'user_id=' + this.user.id;
      query += '&app_id=' + application_id;
      query += '&branch_id=' + this.d_applicationBranchData.data.id;
      query += '&version_id=' + version_id;
      WamAdminService.application_project_version_data(query)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          if (resp.data.status_code === "8000" && resp.data.version_data) {
            this.d_applicationVersionData.data = resp.data.version_data;
            let layer_type = 'system_users_appprojects_appbranchs_appversions';
            let w_id_list = [];
            w_id_list.push(this.user.id);
            w_id_list.push(this.d_selectedApplicationData.id);
            w_id_list.push(this.d_applicationBranchData.data.id);
            w_id_list.push(this.d_applicationVersionData.data.id);
            this.f_updateUrlIframe(this.d_applicationVersionData, 'url_show_iframe', this.f_createUrlIframeShow(layer_type, w_id_list));
          } else {
            //
          }
        }), resp => {
          this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
        };
    },
    f_wdmList: function () {
      let data = {
        'key_list': ['wdm_wisdom_wdm307_v2.0', 'wdm_wisdom_wdm17_v2.0'],
        'bucket': 'option'
      };
      GlobalService.get_multiple_cb_documents(data)
        .then(resp => {
          if (resp.data.status === 'success') {
            for (let i in resp.data.result) {
              this.option_data[resp.data.result[i].parent] = resp.data.result[i];
              this.d_wisdomData.option_data[resp.data.result[i].parent] = resp.data.result[i];
            }
            this.f_prepareOrganizationFilterData();
          } else {
            console.log('error ', resp.data.message);
          }
        });
    },
    f_goToLink: function (url) {
      window.open(url, '_blank');
    },
    f_createMenuData: function () {
      /*
        BE CAREFUL !!!!!!!!!!!!!!!!!!!!!!1
        WHEN YOU CHANGED THE ITEMS ORDER, THERE MAY BE A PROBLEM IN CODES. IF YOU WANT TO CHANGE ORDER, CONTROL WHETHER YOU USED ITEMS AS ITEM INDEX IN SOME WHERE IN YOU CODE.
      */
      this.d_menuData = {
        'forceUpdate': 0,
        'selected_menu': 'organization', // your defined menu value below
        'style': {
          'height': '150',
          'backgroundColor': 'black',
          'subBackgroundColor': 'green',
          'subColor': 'green',
          'color': 'green',
          'main_header': {
            'backgroundColor': 'black',
            'color': 'green'
          },
          'tab_header': {
            'backgroundColor': 'black',
            'color': 'green'
          }
        },
        'list': [{
          'label': 'Project',
          'icon': require('../../icon/1705440.png'),
          'value': 'organization',
          'list': [{
            'icon': '',
            'label': 'General',
            'value': 'general',
            'list': [{
              'type': 'button', // button, buttongroup, color
              'title': 'Application Projects',
              'icon': require('../../icon/2504347.png'),
              'label': '',
              'value': 'general',
              'click': this.f_openApplicationList
            }, {
              'type': 'button', // button, buttongroup, color
              'title': 'New Project',
              'icon': require('../../icon/2766751.png'),
              'label': '',
              'value': 'general',
              'click': this.f_newApplication
            }, {
              'type': 'button', // button, buttongroup, color
              'title': 'Merge Branches',
              'icon': require('../../icon/136161.png'),
              'label': '',
              'value': 'general',
              'click': this.f_openMergeManyAppsModal
            }]
          }]
        }, {
          'label': 'Ecosystem',
          'icon': require('../../icon/3012411.png'),
          'value': 'operation',
          'list': [{
            'icon': '',
            'label': 'General',
            'value': 'general',
            'list': [{
              'type': 'button', // button, buttongroup, color
              'title': 'Ecosystems',
              'icon': require('../../icon/2504347.png'),
              'label': 'Ecosystems',
              'value': 'general',
              'click': this.f_openEcosystemList
            }, {
              'type': 'button', // button, buttongroup, color
              'title': 'New Ecosystem',
              'icon': require('../../icon/2766751.png'),
              'label': 'New Ecosystem',
              'value': 'general',
              'click': this.f_newEcosystem
            }, {
              'type': 'button', // button, buttongroup, color
              'title': 'Edit application settings in the ecosystem',
              'icon': require('../../icon/2556829.png'),
              'label': 'Edit application settings in the ecosystem',
              'value': 'general',
              'click': this.f_updateDatabaseConnectionStringForAllEcosystemApplications
            }, {
              'type': 'button', // button, buttongroup, color
              'title': 'Create application production branch friend configs automatically in the ecosystem',
              'icon': require('../../icon/1994869.png'),
              'label': 'Create application production branch friend configs automatically in the ecosystem',
              'value': 'general',
              'click': this.f_ecosystemServerApplicationBranchFriendUpdate
            }]
          }]
        }, {
          'label': 'Help',
          'icon': require('@/icon/2249810.png'),
          'value': 'help',
          'list': [{
            'icon': require('@/icon/2249810.png'),
            'label': 'General',
            'value': 'general',
            'list': []
          }]
        }]
      };
      this.f_filterMenuIndex();
    },
    f_filterMenuIndex: function () {
      for (let i in this.d_menuData.list) {
        if (this.d_menuData.list[i].value === 'filter') {
          this.d_menuFilterIndex = i;
          break;
        }
      }
    },
    f_wisdomShowUpdate: function () {
      if (this.change === "0") {
        this.change = "1";
      } else {
        this.change = "0";
      }
      this.$forceUpdate();
    },
    f_openStatusModal: function (task_ind) {
      this.d_applyStatusOperation.selected_index = '';
      this.d_applyStatusOperation.task_ind = task_ind;
      this.d_applyStatusOperation.show = true;
    },
    f_openEcosystemList: function () {
      this.d_ecosystemData.show = true;
    },
    f_getOrganizationList: function () {
      let layer_type = 'user_organizations';
      let w_id_list = JSON.parse(JSON.stringify(this.d_WmanagerLayerData[layer_type].w_id_list));
      w_id_list.push(this.d_wdm22.id);
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Organizasyonlar getirme işlemi gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      WmanagerApi.get_wdmr_list_by_wdmr_id(layer_type, w_id_list, 0)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log(resp);
          this.d_applicationListData.list = resp.list;
          if (this.$route.query && this.$route.query.organization_id !== undefined) {
            if (this.$route.query.operation_no !== undefined) {
              this.d_filter.operation_no = this.$route.query.operation_no;
            }
            for (let i in this.d_applicationListData.list) {
              if (this.d_applicationListData.list[i].w_id === this.$route.query.organization_id) {
                this.f_selectApplication(parseInt(i));
                break;
              }
            }
          }
        }, resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          let msg = JSON.stringify(resp);
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Organizasyon getirme işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
          console.log(resp);
        });
    },
    f_getAllWdm22List: function () {
      let data = {
        'parent_wdm': { 'key': 'wdm233_1', 'type': 'wdm233', 'bucket': 'wisdom' },
        'child_wdm': { 'type': 'wdm22', 'bucket': 'wisdom' },
        'relation_type': 'keys',
        'type': 'only_relation_list', // only_relation_list or get_wdmr_data
        'layer_type': 'first' // first or all
      };
      WdmService.get_wdmr_tree_list(data)
        .then(resp => {
          if (resp.data.status === "success") {
            this.d_allWdm22list = [];
            for (let i in resp.data.result.list) {
              if (resp.data.result.list[i].key !== 'wdm22_' + this.d_wdm22.id) {
                this.d_allWdm22list.push({ 'label': resp.data.result.list[i].label, 'key': resp.data.result.list[i].key });
              }
            }
          } else {
            console.log('errorr get_wdmr_tree_list : ', resp.data.message);
          }
        });
    },
    f_getWdm17OfSelectedOrganization: function () {
      if (this.d_applicationListData.selected_index !== '') {
        this.d_allTaskList = [];
        this.d_taskList = [];
        let wdm307_id = this.d_applicationListData.list[this.d_applicationListData.selected_index].w_id;
        this.f_getWdm17OfThisOrganization(wdm307_id);
      } else {
        let msg = 'Lütfen öncelikle organizasyon seçimi yapınız';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Organizasyon düzenleme işlemi hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      }
    },
    f_getWdm17OfThisOrganization: function (wdm307_id) {
      // console.log('wdm307_id: ', wdm307_id);
      this.d_allTaskList = [];
      this.d_taskList = [];
      let layer_type = 'operation';
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Organizasyona ait operasyonlar getirme işlemi gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      let w_id_list = [];
      w_id_list.push(wdm307_id);
      // console.log('w_id_list: ', w_id_list);
      /*
        d_pagination: {
          'start': 0,
          'end': 49,
          'current': 0,
          'perpage': 50
        },
      */
      let limit = this.d_pagination.perpage.toString();
      let offset = this.d_pagination.start.toString();
      let start_type = 'end';
      // let start_type = 'beginning';
      WmanagerApi.get_wdmr_list_by_wdmr_id(layer_type, w_id_list, '1', limit, offset, start_type)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log('f_getWdm17OfThisOrganization: WmanagerApi.get_wdmr_list_by_wdmr_id response: ', resp);
          for (let i in resp.list) {
            if (resp.list[i].wdmr) {
              // console.log(i);
              this.d_allTaskList.push(resp.list[i].wdmr);
            }
          }
          this.f_updateOperations();
        }, resp => {
          console.log(resp);
        });
    },
    f_updateOperations: function () {
      let new_task_list = [];
      for (let i in this.d_allTaskList) {
        let x = this.f_applyFilterOperationRule(this.d_allTaskList[i]);
        if (x) {
          new_task_list.push(this.d_allTaskList[i]);
        }
      }
      this.d_taskList = new_task_list;
      this.$forceUpdate();
    },
    f_applyFilterOperationRule: function (wdmr17) {
      // kullanıcı 0, öncelik, 1, durum, 2, operasyon tipi 3
      if (wdmr17 && wdmr17.data && wdmr17.data.general) {
        if (this.d_filter.operation_no !== '') {
          if (wdmr17.id !== this.d_filter.operation_no) {
            return false;
          }
        } else {
          if (this.d_filter.search_text) {
            let x = true;
            let y = true;
            try {
              x = wdmr17.data.general.operation_name.val.toLocaleLowerCase().indexOf(this.d_filter.search_text.toLocaleLowerCase()) !== -1;
            } catch (err) {}
            try {
              y = wdmr17.data.general.note.val.toLocaleLowerCase().indexOf(this.d_filter.search_text.toLocaleLowerCase()) !== -1;
            } catch (err) {}
            if (!x && !y) {
              return false;
            }
          } else {
            let user_id_list_who_assigned = this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].selected_option_list;
            // console.log('user_id_list_who_assigned', user_id_list_who_assigned);
            if (user_id_list_who_assigned.length > 0) {
              // if we find any user who is assigned to this task, we will accept this operation det_one_user is true.
              let det_one_user = false;
              try {
                for (let i in wdmr17.data.general.log.list) {
                  let log_user_id = wdmr17.data.general.log.list[i].log_user.val.value;
                  let log_status = wdmr17.data.general.log.list[i].log_status.val.value;
                  // console.log('log_user_id: ', log_user_id);
                  if (user_id_list_who_assigned.indexOf(log_user_id) !== -1 && log_status === 'assigned') {
                    det_one_user = true;
                    break;
                  }
                }
              } catch (err) {}
              if (!det_one_user) {
                return false;
              }
            }
            let assigned_user_id_list = this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].selected_option_list;
            // console.log('assigned_user_id_list', assigned_user_id_list);
            if (assigned_user_id_list.length > 0) {
              // if we find any user who is assigned to this task, we will accept this operation det_one_user is true.
              let det_one_user = false;
              try {
                for (let i in wdmr17.data.general.log.list) {
                  let which_user_log_id = wdmr17.data.general.log.list[i].which_user_log.val.value;
                  let log_status = wdmr17.data.general.log.list[i].log_status.val.value;
                  // console.log('which_user_log_id: ', which_user_log_id);
                  if (assigned_user_id_list.indexOf(which_user_log_id) !== -1 && log_status === 'assigned') {
                    det_one_user = true;
                    break;
                  }
                }
              } catch (err) {}
              if (!det_one_user) {
                return false;
              }
            }
            let priority_list = this.d_menuData.list[this.d_menuFilterIndex].list[2].list[0].selected_option_list;
            if (priority_list.length > 0) {
              if (!wdmr17.data.general.priority || (wdmr17.data.general.priority && priority_list.indexOf(wdmr17.data.general.priority.val.value) === -1)) {
                return false;
              }
            }
            let status_list = this.d_menuData.list[this.d_menuFilterIndex].list[3].list[0].selected_option_list;
            if (status_list.length > 0) {
              if (!wdmr17.data.general.status || (wdmr17.data.general.status && status_list.indexOf(wdmr17.data.general.status.val.value) === -1)) {
                return false;
              }
            }
            let task_type_list = this.d_menuData.list[this.d_menuFilterIndex].list[4].list[0].selected_option_list;
            if (task_type_list.length > 0) {
              if (!wdmr17.data.general.task_type || (wdmr17.data.general.task_type && task_type_list.indexOf(wdmr17.data.general.task_type.val.value) === -1)) {
                return false;
              }
            }
          }
        }
        return true;
      } else {
        return false;
      }
    },
    f_getWdm22OfThisOrganization: function (wdm307_id) {
      let layer_type = 'organization_users';
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Organizasyon kullanıcılarını getirme işlemi gerçekleştiriliyor. Lütfen bekleyiniz.' } });
      // let w_id_list = JSON.parse(JSON.stringify(this.d_WmanagerLayerData[layer_type].w_id_list));
      let w_id_list = [];
      w_id_list.push(wdm307_id);
      WmanagerApi.get_wdmr_list_by_wdmr_id(layer_type, w_id_list, 0)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log('f_getWdm22OfThisOrganization: WmanagerApi.get_wdmr_list_by_wdmr_id response: ', resp);
          this.d_organizationWdm22List = resp.list;
          this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].option_list = [];
          this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].selected_option_list = [];
          // this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].selected_option_list.push(this.d_wdm22.id);
          this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].option_list = [];
          this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].selected_option_list = [];
          // console.log('this.d_wdm22: ', this.d_wdm22.id);
          this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].selected_option_list.push(this.d_wdm22.id);
          for (let i in this.d_organizationWdm22List) {
            let wdm22_id = this.d_organizationWdm22List[i].w_id;
            let user_label = this.d_organizationWdm22List[i].label;
            this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].option_list.push({ 'label': user_label, 'value': wdm22_id });
            this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].option_list.push({ 'label': user_label, 'value': wdm22_id });
          }
          this.f_sortObjectList(this.d_menuData.list[this.d_menuFilterIndex].list[0].list[0].option_list, 'label', 1);
          this.f_sortObjectList(this.d_menuData.list[this.d_menuFilterIndex].list[1].list[0].option_list, 'label', 1);
          this.f_topMenuUpdate();
        }, resp => {
          console.log(resp);
        });
    },
    f_openApplicationList: function () {
      this.d_applicationListData.show = true;
    },
    f_newOrganization: function () {
      this.f_newWdmr('organization');
      // let data_type = 'wdm307';
      // this.d_wisdomData.wisdom_op = 'new';
      // this.d_wisdomData.data_type = 'wdm307';
      // this.d_selectedWdm22IdList = [];
      // ClsWdmrManage.prepare_new_wisdom_data(this.d_wisdomData, data_type);
      // this.d_wisdomData.show = true;
    },
    f_saveNewOrganization: function (layer_type = 'organization') {
      if (this.d_selectedWdm22IdList.length === 0) {
        let msg = 'Lütfen öncelikle kullanıcı seçimi yapınız';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Organizasyon kaydı hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      } else {
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Organizasyon kayıt işlemi gerçekleştiriliyor. Lütfen bekleyiniz.' } });
        WmanagerApi.get_wdmr_list_by_wdmr_id(layer_type, this.d_WmanagerLayerData[layer_type].w_id_list, 1)
          .then(resp => {
            // console.log(resp);
            let organization_id = resp.list[0].w_id;
            let organization_label = resp.list[0].label;
            let data = { 'list': [] };

            let parent_wdm307 = {};
            parent_wdm307.parent_type = 'wdm307';
            parent_wdm307.parent_id_list = [];
            parent_wdm307.child_type = 'wdm22';
            parent_wdm307.child_info_list = [];

            parent_wdm307.parent_id_list.push(organization_id);
            for (let i in this.d_allWdm22list) {
              if (this.d_selectedWdm22IdList.indexOf(this.d_allWdm22list[i].key) !== -1) {
                parent_wdm307.child_info_list.push(this.d_allWdm22list[i]);
              }
            }
            parent_wdm307.child_info_list.push({ 'key': 'wdm22_' + this.d_wdm22.id, 'label': this.d_wdm22.label });

            let parent_wdm22 = {};
            parent_wdm22.parent_type = 'wdm22';
            parent_wdm22.parent_id_list = [];
            parent_wdm22.child_type = 'wdm307';
            parent_wdm22.child_info_list = [];
            parent_wdm22.child_info_list.push({ 'key': 'wdm307_' + organization_id, 'label': organization_label })

            parent_wdm22.parent_id_list.push(this.d_wdm22.id);
            for (let i in this.d_selectedWdm22IdList) {
              parent_wdm22.parent_id_list.push(this.d_selectedWdm22IdList[i].split('wdm22_')[1]);
            }

            data['list'].push(parent_wdm307);
            data['list'].push(parent_wdm22);

            WmanagerApi.relation_docs_add(data)
              .then(resp => {
                // console.log(resp);
                this.$store.commit('Loading', { 'status': false, 'data': {} });
                this.d_wisdomData.show = false;
              }, resp => {
                console.log(resp);
              });
          }, resp => {});
      }
    },
    f_addRemoveUser: function (user) {
      if (this.d_selectedWdm22IdList.indexOf(user.w_id) === -1) {
        this.d_selectedWdm22IdList.push(user.w_id);
      } else {
        this.d_selectedWdm22IdList.splice(this.d_selectedWdm22IdList.indexOf(user.w_id), 1);
      }
      this.$forceUpdate();
    },
    f_newWdmr: function (layer_type, edit_wdmr = false, w_id_list = [], show_modal = true) {
      this.d_WmanagerLayerData[layer_type].w_id_list = [];
      let wmanager_local_storage = JSON.parse(localStorage.getItem('wmanager'));
      if (edit_wdmr) {

      } else {
        WmanagerApi.prepare_wdmr(layer_type, edit_wdmr, w_id_list)
          .then(resp => {
            // console.log(resp);
            this.d_WmanagerLayerData[layer_type].w_id_list = JSON.parse(JSON.stringify(w_id_list));
            if (!edit_wdmr) {
              this.d_WmanagerLayerData[layer_type].w_id_list.push(resp.w_id);
            }
            this.d_WmanagerLayerData[layer_type].url_show_iframe = this.WDMR_LINKS['show'] + 'layer_id=' + this.d_WmanagerLayerData[layer_type].layer_id + '&w_id_list=' + this.d_WmanagerLayerData[layer_type].w_id_list.join(',') + '&wisdom=' + wmanager_local_storage.access_token + '&modsiw=' + wmanager_local_storage.refresh_token;

            this.rmdw = layer_type;
            if (edit_wdmr) {
              this.d_isDataNewOrEdit = 'edit';
            } else {
              this.d_isDataNewOrEdit = 'new';
            }
            this.d_dataType = this.d_WmanagerLayerData[layer_type].wdm_type;
            if (show_modal) {
              this.d_wisdomData.show = true;
            }
          }, resp => {
            console.log(resp);
          });
      }
    },
    f_newApplication: function () {
      if (confirm('Yeni uygulama projesi oluşturmak istediğinize emin misiniz ?')) {
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Yeni uygulama projesi oluşturuluyor. Lütfen bekleyiniz.' } });
        let query = 'user_id=' + this.user.id;
        let data = {
          'wdmr': {
            'label': 'New Application',
            'data': {
              'general': {
                'name': { 'val': 'New Application' }
              }
            }
          }
        };
        this.d_applicationListData.url_show_iframe = '';
        WamAdminService.application_save(query, data)
          .then(resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            if (resp.data.status_code === "8000" && resp.data.application_data && resp.data.application_data.id) {
              this.d_applicationListData.list.push(resp.data.application_data);
              this.d_selectedApplicationData = resp.data.application_data;
              this.f_editSelectedApplicationWdmr();
              this.f_selectApplication(this.d_applicationListData.list.length - 1);
            } else {
              let msg = JSON.stringify(resp);
              let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Uygulama projesi kayıt işlemi hakkında' };
              this.$store.commit('modal', modal_data);
              this.$store.commit('modal_show', true);
            }
            //
          }), resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          };
      }
    },
    f_newEcosystem: function () {
      if (confirm('Yeni ekosistem oluşturmak istediğinize emin misiniz ?')) {
        this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Yeni uygulama ekosistemi oluşturuluyor. Lütfen bekleyiniz.' } });
        let query = 'user_id=' + this.user.id;
        let data = {
          'wdmr': {
            'label': 'New Ecosystem',
            'data': {
              'general': {
                'name': { 'val': 'New Ecosystem' }
              }
            }
          }
        };
        this.d_ecosystemData.url_show_iframe = '';
        WamAdminService.ecosystem_save(query, data)
          .then(resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
            if (resp.data.status_code === "8000" && resp.data.ecosystem_data && resp.data.ecosystem_data.id) {
              this.d_ecosystemData.list.push(resp.data.ecosystem_data);
              this.d_ecosystemData.data = resp.data.ecosystem_data;
              this.f_editSelectedEcosystemWdmr();
              this.f_selectEcosystem(this.d_ecosystemData.list.length - 1);
            } else {
              let msg = JSON.stringify(resp);
              let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Uygulama projesi kayıt işlemi hakkında' };
              this.$store.commit('modal', modal_data);
              this.$store.commit('modal_show', true);
            }
            //
          }), resp => {
            this.$store.commit('Loading', { 'status': false, 'data': { 'label': '' } });
          };
      }
    },
    f_getWmanagerWdmr: function (layer_type) {
      WmanagerApi.get_wdmr_list_by_wdmr_id(layer_type, this.d_WmanagerLayerData[layer_type].w_id_list, 1)
        .then(resp => {
          // console.log(resp);
          try {
            return resp.list[0];
          } catch (err) {
            return false;
          }
        }, resp => {
          return false;
          console.log(resp);
        });
    },
    f_saveOperationStatus: function (selected_status, task_ind) {
      let which_user_log = {
        'val': {
          'label': this.user.first_name + ' ' + this.user.last_name,
          'value': this.d_wdm22.id
        }
      };
      let operation_data = this.d_taskList[task_ind];
      this.f_addStatusAsLogToTask(operation_data, selected_status, which_user_log);
      let layer_type = 'operation';
      let w_id_list = [this.d_selectedWdmr307.id, operation_data.id];
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Operasyon kayıt işlemi tamamlanıyor. Lütfen bekleyiniz.' } });
      WmanagerApi.prepare_wdmr(layer_type, operation_data, w_id_list)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log(resp);
          this.d_taskList[task_ind].cas = resp.cas;
          let operation_text = ' *** Durum değişimi: ' + selected_status.label + ' *** ';
          this.f_sendMessageOverWconnectToOtherUsers(operation_data, operation_text);
          this.d_applyStatusOperation.show = false;
          this.f_updateOperations()
          let msg = 'İşlem tamamlandı.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon durum değişim işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }, resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          console.log(resp);
          let msg = JSON.stringify(resp);
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon durum değişim işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        });
    },
    f_sendMessageOverWconnectToOtherUsers: function (wdmr17, operation_text) {
      let uniq_wdm22_id_list = [];
      for (let i in wdmr17.data.general.log.list) {
        let log_user_id = wdmr17.data.general.log.list[i].log_user.val.value;
        if (this.d_wdm22.id !== log_user_id && uniq_wdm22_id_list.indexOf(log_user_id) === -1) {
          uniq_wdm22_id_list.push(log_user_id);
        }
        let which_user_log_id = wdmr17.data.general.log.list[i].which_user_log.val.value;
        if (this.d_wdm22.id !== which_user_log_id && uniq_wdm22_id_list.indexOf(which_user_log_id) === -1) {
          uniq_wdm22_id_list.push(which_user_log_id);
        }
      }
      if (uniq_wdm22_id_list.length > 0) {
        let subject = this.user.username + ', Op No: ' + wdmr17.id + ' / ' + this.d_selectedWdmr307.label;
        let url = 'https://organization.wisdomera.io/#/operations?organization_id=' + this.d_selectedWdmr307.id + '&operation_no=' + wdmr17.id;
        let mail_text = '';
        mail_text += '<div>' + operation_text + '</div>';
        mail_text += this.f_prepareOperationMailDetailed(wdmr17);
        this.f_sendMail(subject, uniq_wdm22_id_list, mail_text);
        for (let i in uniq_wdm22_id_list) {
          let sender_id = this.d_wdm22.id;
          let to_id = uniq_wdm22_id_list[i];
          let msg = 'Worganization: <<< ' + this.d_selectedWdmr307.label + ' >>> <<< ' + wdmr17.label + ' >>> ' + operation_text +
            'https://organization.wisdomera.io/#/operations?organization_id=' + this.d_selectedWdmr307.id + '&operation_no=' + wdmr17.id;
          this.f_sendMessageToWconnect(sender_id, to_id, msg);
        }
      } else {
        let subject = this.user.username + ', Op No: ' + wdmr17.id + ' / ' + this.d_selectedWdmr307.label;
        let url = 'https://organization.wisdomera.io/#/operations?organization_id=' + this.d_selectedWdmr307.id + '&operation_no=' + wdmr17.id;
        let mail_text = '';
        mail_text += '<div>' + operation_text + '</div>';
        mail_text += this.f_prepareOperationMailDetailed(wdmr17);
        this.f_sendMail(subject, [this.d_wdm22.id], mail_text);
      }
    },
    f_sendAllUsersMailAboutThisOperation: function (wdmr17) {
      let uniq_wdm22_id_list = this.f_getAllLogUserIdListAsUniq(wdmr17);
      if (uniq_wdm22_id_list.length > 0) {
        let subject = this.user.username + ', Op, No: ' + wdmr17.id + ' / ' + this.d_selectedWdmr307.label;
        let mail_text = this.f_prepareOperationMailDetailed(wdmr17);
        let document_list = [];
        if (wdmr17.document_list && wdmr17.document_list.length > 0) {
          document_list = wdmr17.document_list;
        }
        this.f_sendMail(subject, uniq_wdm22_id_list, mail_text, document_list);
      }
    },
    f_getAllLogUserIdListAsUniq: function (wdmr17) {
      let uniq_wdm22_id_list = [];
      for (let i in wdmr17.data.general.log.list) {
        let log_user_id = wdmr17.data.general.log.list[i].log_user.val.value;
        if (uniq_wdm22_id_list.indexOf(log_user_id) === -1) {
          uniq_wdm22_id_list.push(log_user_id);
        }
        let which_user_log_id = wdmr17.data.general.log.list[i].which_user_log.val.value;
        if (uniq_wdm22_id_list.indexOf(which_user_log_id) === -1) {
          uniq_wdm22_id_list.push(which_user_log_id);
        }
      }
      return uniq_wdm22_id_list;
    },
    f_prepareOperationMailDetailed: function (wdmr17) {
      let mail_text = '<div><strong>Operasyon Genel Bilgileri</strong></div>';
      mail_text += '<div><strong>Organizasyon:</strong><span>' + this.d_selectedWdmr307.label + '</span></div>';
      mail_text += '<div><strong>Operasyon Adı:</strong><span>' + wdmr17.data.general.operation_name.val + '</span></div>';
      mail_text += '<div><strong>Operasyon Notu:</strong><span>' + wdmr17.data.general.note.val + '</span></div>';
      mail_text += '<div><strong>Öncelik:</strong><span>' + wdmr17.data.general.priority.val.label + '</span></div>';
      mail_text += '<div><strong>Operasyon Tipi:</strong><span>' + wdmr17.data.general.task_type.val.label + '</span></div>';
      mail_text += '<div><strong>Durum:</strong><span>' + wdmr17.data.general.status.val.label + '</span></div>';
      if (wdmr17.data.general.comment && wdmr17.data.general.comment.list && wdmr17.data.general.comment.list.length > 0) {
        mail_text += '<div> <strong>--- Yorumlar ---</strong> </div>';
        for (let i in wdmr17.data.general.comment.list) {
          mail_text += '<div>' + wdmr17.data.general.comment.list[i].who_commented.val.label + ' ( ' + this.DateFormatWithTime(wdmr17.data.general.comment.list[i].comment_datetime.val) + ' ) ' + ': </div>';
          mail_text += '<div>' + wdmr17.data.general.comment.list[i].message.val + '</div>';
        }
      }
      if (wdmr17.data.general.log && wdmr17.data.general.log.list && wdmr17.data.general.log.list.length > 0) {
        mail_text += '<div> <strong>--- Loglar ---</strong> </div>';
        for (let i in wdmr17.data.general.log.list) {
          mail_text += '<div>' + wdmr17.data.general.log.list[i].log_user.val.label + ' ( ' + this.DateFormatWithTime(wdmr17.data.general.log.list[i].log_datetime.val) + ' - ' + wdmr17.data.general.log.list[i].log_status.val.label + ' ) -> ' + wdmr17.data.general.log.list[i].which_user_log.val.label + ' </div>';
        }
      }
      if (wdmr17.data.general.work_time && wdmr17.data.general.work_time.list && wdmr17.data.general.work_time.list.length > 0) {
        mail_text += '<div> <strong>--- Çalışma Notları ---</strong> </div>';
        for (let i in wdmr17.data.general.work_time.list) {
          mail_text += '<div><strong>Not - ' + (parseInt(i) + 1).toString() + '</strong></div>';
          mail_text += '<div>başlama:' + this.DateFormatWithTime(wdmr17.data.general.work_time.list[i].start.val) + '</div>';
          mail_text += '<div>bitiş:' + this.DateFormatWithTime(wdmr17.data.general.work_time.list[i].end.val) + '</div>';
          mail_text += '<div>' + wdmr17.data.general.work_time.list[i].work_time_note.val + '</div>';
        }
      }
      let url = 'https://organization.wisdomera.io/#/operations?organization_id=' + this.d_selectedWdmr307.id + '&operation_no=' + wdmr17.id;
      mail_text += '<div><a href="' + url + '">Operasyonuna gitmek için tıklayınız.</a></div>';
      return mail_text;
    },
    f_getAssignedListOfThisOperation: function (wdmr17) {
      let wdm22_keys_list = [];
      for (let i in wdmr17.data.general.log.list) {
        if (wdmr17.data.general.log.list[i].log_status.val.value === 'assigned') {
          let wdm22_key = 'wdm22_' + wdmr17.data.general.log.list[i].which_user_log.val.value;
          wdm22_keys_list.push(wdm22_key);
        }
      }
      return wdm22_keys_list;
    },
    f_saveNewOperation: function () {
      if (this.d_selectedWdm22IdList.length === 0) {
        let msg = 'Lütfen öncelikle kullanıcı seçimi yapınız';
        let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon kaydı hakkında' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
      } else {
        WmanagerApi.get_wdmr_list_by_wdmr_id('operation', this.d_wisdomData.w_id_list, 1)
          .then(resp => {
            this.d_wisdomData.show = false;
            // console.log(resp);
            let operation_data = resp.list[0].wdmr;
            if (this.d_wisdomData.operation_user_type === 'same_operation_to_everyone') {
              this.d_allTaskList.push(operation_data);
              this.f_updateOperations();
              this.f_addUserListToOperation(operation_data, this.d_selectedWdm22IdList);
              let operation_id = operation_data.id;
              let operation_label = operation_data.label;
              this.f_saveOperationFast(this.d_allTaskList.length - 1, operation_data);
              this.f_addOperationToUserAndOrganizations(operation_data, this.d_selectedWdm22IdList);
            } else if (this.d_wisdomData.operation_user_type === 'copy_to_everyone') {
              let new_operation_data = JSON.parse(JSON.stringify(operation_data));
              if (new_operation_data.id) {
                this.$delete(new_operation_data, 'id');
              }
              if (new_operation_data.cas) {
                this.$delete(new_operation_data, 'cas');
              }
              for (let i in this.d_selectedWdm22IdList) {
                let new_user_list = [];
                let prepare_operation_data = JSON.parse(JSON.stringify(new_operation_data));
                new_user_list.push(this.d_selectedWdm22IdList[i]);
                // console.log(new_user_list);
                this.f_addUserListToOperation(prepare_operation_data, new_user_list);
                let layer_type = 'operation';
                let w_id_list = [this.d_selectedWdmr307.id];
                WmanagerApi.prepare_wdmr(layer_type, prepare_operation_data, w_id_list)
                  .then(resp => {
                    // console.log(resp);
                    prepare_operation_data.cas = resp.cas;
                    prepare_operation_data.id = resp.w_id;
                    this.d_allTaskList.push(prepare_operation_data);
                    this.f_updateOperations();
                    this.f_addOperationToUserAndOrganizations(prepare_operation_data, new_user_list);
                  }, resp => {
                    console.log(resp);
                  });
              }
            }
            let msg = 'Operasyon kayıt işlemi tamamlandı.';
            let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon kaydı hakkında' };
            this.$store.commit('modal', modal_data);
            this.$store.commit('modal_show', true);
          }, resp => {
            this.f_addOperationToUserAndOrganizations(operation_data, this.d_selectedWdm22IdList);
          });
        // this.$route.query.organization_id
      }
    },
    f_addUserListToOperation: function (operation_data, user_list) {
      let selected_status = { 'value': 'assigned', 'label': 'Atandı' };
      for (let i in user_list) {
        let which_user_log = '';
        for (let k in this.d_organizationWdm22List) {
          if (user_list[i] === this.d_organizationWdm22List[k].w_id) {
            // console.log("this.d_organizationWdm22List[k].key.split('wdm22_')", this.d_organizationWdm22List[k].key.split('wdm22_'));
            which_user_log = {
              'val': {
                'label': this.d_organizationWdm22List[k].label,
                'value': this.d_organizationWdm22List[k].w_id
              }
            };
            break;
          }
        }
        // console.log('which_user_log', which_user_log);
        this.f_addStatusAsLogToTask(operation_data, selected_status, which_user_log);
        // console.log('this.d_wisdomData.wisdom_data', this.d_wisdomData.wisdom_data);
      }
    },
    f_addOperationToUserAndOrganizations: function (operation_data, user_list) {
      let data = { 'list': [] };
      let parent_wdm307 = {};
      parent_wdm307.parent_type = 'wdm307';
      parent_wdm307.parent_id_list = [];
      parent_wdm307.child_type = 'wdm17';
      parent_wdm307.child_info_list = [];

      parent_wdm307.parent_id_list.push(this.d_selectedWdmr307.id);
      parent_wdm307.child_info_list.push({ 'key': 'wdm17_' + operation_data.id, 'label': operation_data.label });

      let parent_wdm22 = {};
      parent_wdm22.parent_type = 'wdm22';
      parent_wdm22.parent_id_list = [];
      parent_wdm22.child_type = 'wdm17';
      parent_wdm22.child_info_list = [];
      parent_wdm22.child_info_list.push({ 'key': 'wdm17_' + operation_data.id, 'label': operation_data.label })

      for (let i in user_list) {
        parent_wdm22.parent_id_list.push(user_list[i]);
      }

      data['list'].push(parent_wdm307);
      data['list'].push(parent_wdm22);
      // console.log(data);
      WmanagerApi.relation_docs_add(data)
        .then(resp => {
          let operation_text = 'operasyon ataması yapılmıştır.';
          this.f_sendMessageOverWconnectToOtherUsers(operation_data, operation_text);
          this.d_wisdomData.show = false;
          // console.log(resp);
        }, resp => {
          console.log(resp);
        });
    },
    f_saveWdmr17OfOrganization: function (wdmr17) {
      this.d_wisdomData.wisdom_data = wdmr17;
      let parent_wdm = '';
      let child_wdm = '';
      let relation_type = 'keys';
      let both_parent = 'no';
      let wdmr307_key = this.d_applicationListData.list[this.d_applicationListData.selected_index].key;
      parent_wdm = {
        'label': '',
        'key_list': [wdmr307_key],
        'bucket': 'wisdom',
        'type': 'wdm22'
      };
      child_wdm = {
        'label': '',
        'key': 'wdm_wisdom_wdm17_v2.0',
        'bucket': 'wisdom',
        'type': 'wdm17'
      };
      ClsWdmrManage.save_child_wdmr(this.d_wisdomData, parent_wdm, child_wdm, relation_type, both_parent)
        .then(resp => {
          // this.d_selectedWdmrData = resp.wdmr;
          // this.wisdom_show_update();
          this.f_updateOperations();
          // We control whether this user is the assigned user. himself ?.
          let operation_text = 'operasyon ataması yapılmıştır.';
          this.f_sendMessageOverWconnectToOtherUsers(wdmr17, operation_text);
          let msg = 'Operasyon kayıt işlemi tamamlandı.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon kaydı hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }, resp => {
          alert('error ', resp);
        });
    },
    f_sendMessageToWconnect: function (sender_id, to_id, msg) {
      let data = {
        'sender': sender_id,
        'to': to_id,
        'message': msg
      };
      // console.log(data);
      WconnectService.send_message(data)
        .then(resp => {
          if (resp.data.status === "success") {
            console.log('message sent');
          } else {
            console.log('errorr get_one_cb_document : ', resp.data.message);
          }
        });
    },
    f_sendMail: function (subject, to_whom_user_id_list, mail_text, document_list = [], from_user = { 'value': '1', 'label': 'wisdom' }, from_mail = 'info@wisdomera.io') {
      let mail_wdmr = {
        'data': {
          'general': {
            'subject': { 'val': subject },
            'from_mail': { 'val': from_mail },
            'from_user': { 'val': from_user },
            'to_whom': { 'list': [] },
            'mail_text': { 'val': mail_text },
          }
        }
      };
      if (document_list.length > 0) {
        mail_wdmr.data.general.attachment = { 'list': [] };
        for (let i in document_list) {
          let x = {
            'attachment_name': { 'val': document_list[i].file_name },
            'file': { 'val': document_list[i].document }
          };
          mail_wdmr.data.general.attachment.list.push(x);
        }
      }
      for (let i in to_whom_user_id_list) {
        let x = {
          'to_whom_user': { 'val': { 'value': to_whom_user_id_list[i], 'label': to_whom_user_id_list[i] } }
        }
        mail_wdmr.data.general.to_whom.list.push(x);
      }
      // console.log(data);
      WmailApi.mail_send(mail_wdmr)
        .then(resp => {
          console.log(resp);
        });
    },
    f_calculatePriorityStyle: function (task) {
      let task_priority = '';
      try {
        task_priority = task.data.general.priority.val.value;
      } catch (err) {
        task_priority = '';
      }
      if (task_priority === 'urgent') {
        return 'float: left; background: red; height: 90%; width: 5px; margin: 1px; border-radius: 7px; box-shadow: -1px -1px 3px;';
      } else if (task_priority === 'high') {
        return 'float: left; background: #ed6e40; height: 90%; width: 5px; margin: 1px; border-radius: 7px; box-shadow: -1px -1px 3px;';
      } else if (task_priority === 'medium') {
        return 'float: left; background: #f1ae54; height: 90%; width: 5px; margin: 1px; border-radius: 7px; box-shadow: -1px -1px 3px;';
      } else if (task_priority === 'low') {
        return 'float: left; background: #f7cd46; height: 90%; width: 5px; margin: 1px; border-radius: 7px; box-shadow: -1px -1px 3px;';
      }
    },
    f_calculateTaskStyle: function (task) {
      let task_priority = '';
      try {
        task_priority = task.data.general.priority.val.value;
      } catch (err) {
        task_priority = '';
      }
      if (task_priority === 'urgent') {
        return 'background: #fbb0b0; border-radius: 7px; margin: 1px; padding: 3px min-height: 20px;';
      } else if (task_priority === 'high') {
        return 'background: #ffb89e; border-radius: 7px; margin: 1px; padding: 3px min-height: 20px;';
      } else if (task_priority === 'medium') {
        return 'background: #fbd29c; border-radius: 7px; margin: 1px; padding: 3px min-height: 20px;';
      } else if (task_priority === 'low') {
        return 'background: #ffecb1; border-radius: 7px; margin: 1px; padding: 3px min-height: 20px;';
      }
    },
    f_topMenuUpdate: function () {
      if (this.d_menuData.forceUpdate) {
        this.d_menuData.forceUpdate = 0;
      } else {
        this.d_menuData.forceUpdate = 1;
      }
    },
    f_prepareOrganizationFilterData: function () {
      // priority
      try {
        this.d_menuData.list[this.d_menuFilterIndex].list[2].list[0].option_list = this.option_data['wdm17'].general.parameters.priority.options;
      } catch (err) {
        console.log(err);
        this.d_menuData.list[this.d_menuFilterIndex].list[2].list[0].option_list = [];
      }
      // status
      try {
        this.d_menuData.list[this.d_menuFilterIndex].list[3].list[0].option_list = this.option_data['wdm17'].general.parameters.status.options;
        this.d_wdm17StateOptions = this.option_data['wdm17'].general.parameters.status.options;
        this.f_sortObjectList(this.d_menuData.list[this.d_menuFilterIndex].list[3].list[0].option_list, 'label', 1);
      } catch (err) {
        console.log(err);
        this.d_menuData.list[this.d_menuFilterIndex].list[3].list[0].option_list = [];
      }
      // operation type
      try {
        this.d_menuData.list[this.d_menuFilterIndex].list[4].list[0].option_list = this.option_data['wdm17'].general.parameters.task_type.options;
        this.f_sortObjectList(this.d_menuData.list[this.d_menuFilterIndex].list[4].list[0].option_list, 'label', 1);
      } catch (err) {
        console.log(err);
        this.d_menuData.list[this.d_menuFilterIndex].list[4].list[0].option_list = [];
      }
      this.f_topMenuUpdate();
    },
    f_sortObjectList: function (object_list, param, asc_or_desc = 1) {
      // sort object list which includes like
      /*
        object_list =
        [
          {'value': 'sdfas', 'label': '5mglld'},
          {'value': 'k5kfm', 'label': 'jfjt8'}
        ]

        param is the key variable in object list. Like example object list "value" or "label"

        asc_or_desc = 1 or -1:
          Sort as ascending (1) or descending (-1)
      */
      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        let param_a = '';
        let param_b = '';
        try {
          param_a = a[param].toLocaleLowerCase();
          param_b = b[param].toLocaleLowerCase();
        } catch (err) {
          param_a = a[param];
          param_b = b[param];
        }

        let comparison = 0;
        if (param_a > param_b) {
          comparison = 1;
        } else if (param_a < param_b) {
          comparison = -1;
        }
        return comparison * asc_or_desc;
      }
      object_list.sort(compare);
    },
    f_dataSetStyle: function (x) {
      let height = window.innerHeight - x;
      let overflow_x = 'auto';
      return 'overflow-y: auto; height:' + height.toString() + 'px; overflow-x:' + overflow_x + '; margin-bottom: 0px; border: none;';
    },
    f_calculateBottomTabStyle: function () {
      let height = '';
      let overflow_x = '';
      if (this.d_fullScreenOperationPage) {
        height = window.innerHeight - 50;
        overflow_x = 'hidden';
      } else {
        height = window.innerHeight - (parseInt(this.d_menuData.style.height) + 310);
        overflow_x = 'hidden';
        // console.log('height: ', height);
      }
      if (this.device.isMobile) {
        return 'margin-bottom: 0px; border: none;';
      } else {
        return 'overflow-y: auto; height:' + height.toString() + 'px; overflow-x:' + overflow_x + '; margin-bottom: 0px; border: none;';
      }
    },
    f_calculateStatusStyle: function (status_val) {
      if (status_val === 'completed') {
        return 'background: #28a745; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'cancelled') {
        return 'background: #f7959e; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'assigned') {
        return 'background: #f6f9b9; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'not_assigned') {
        return 'background: #a3afb6; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'recommended') {
        return 'background: #e08be7; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'refused') {
        return 'background: #c1a4fc; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else if (status_val === 'accepted') {
        return 'background: #01ffe4; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      } else {
        return 'background: orange; border-radius: 3px; border: solid 1px #c6cfd4; text-align: center; padding: 2px; margin: 2px; font-size: 10px; min-width: 75px; white-space: nowrap; float: left; cursor: pointer;';
      }
    },
    f_getIndexListAsString: function (index_list) {
      let str = '';
      for (let i in index_list) {
        let x = index_list[i].split(',');
        for (let k in x) {
          str += (parseInt(x[k]) + 1).toString();
          str += '.';
        }
        if (parseInt(i) !== index_list.length - 1) {
          str += ' - ';
        }
      }
      return str;
    },
    f_getAssignDate: function (task, user) {
      // console.log('user', user);
      try {
        for (let i = 0; i < task.data.general.log.list.length; i++) {
          if (task.data.general.log.list[i].which_user_log.val.value === user.value) {
            let k = this.DateFormatWithTime(task.data.general.log.list[i].log_datetime.val);
            if (k) {
              return k;
            } else {
              return '';
            }
          }
        }
      } catch (err) {}
      // console.log(task.created_at);
      let k = this.DateFormatWithTime(task.created_at);
      if (k) {
        return k;
      } else {
        return '';
      }
    },
    f_getAssignedBy: function (task) {
      // console.log('user', user);
      let user_text = '';
      try {
        for (let i = 0; i < task.data.general.log.list.length; i++) {
          if (task.data.general.log.list[i].log_status.val.value === 'assigned') {
            if (user_text) {
              user_text += ' / ';
            }
            let log_datetime = '';
            if (task.data.general.log.list[i].log_datetime && task.data.general.log.list[i].log_datetime.val) {
              let x = this.DateFormatWithTime(task.data.general.log.list[i].log_datetime.val);
              if (x && x !== 'Invalid date') {
                log_datetime = x;
              }
            }
            // console.log('log_datetime', log_datetime);
            if (log_datetime) {
              user_text += task.data.general.log.list[i].log_user.val.label + ' -> ' + task.data.general.log.list[i].which_user_log.val.label + ' (' + log_datetime + ')';
            } else {
              user_text += task.data.general.log.list[i].log_user.val.label + ' -> ' + task.data.general.log.list[i].which_user_log.val.label;
            }
          }
        }
      } catch (err) {}
      // console.log(task.created_at);
      return user_text;
    },
    f_calculateLastAssignedDate: function (task) {
      try {
        for (let i = 0; i < task.data.general.log.list.length; i++) {
          if (task.data.general.log.list[i].log_status.val.value === 'assigned') {
            let k = this.DateFormatWithTime(task.data.general.log.list[i].log_datetime.val);
            if (k) {
              return k;
            } else {
              return '';
            }
          }
        }
      } catch (err) {}
      return '';
    },
    DateFormatWithTime: function (date) {
      if (date) {
        return moment(date, 'YYYY-MM-DDThh:mm:ss').format('DD/MM/YYYY HH:mm');
      } else {
        return '';
      }
    },
    f_calculateCountOfSeenComments: function (task) {
      if (task.data && task.data.general && task.data.general.comment && task.data.general.comment.list) {
        let count = 0;
        for (let c in task.data.general.comment.list) {
          if (task.data.general.comment.list[c].who_saw && task.data.general.comment.list[c].who_saw.list) {
            for (let w in task.data.general.comment.list[c].who_saw.list) {
              if (task.data.general.comment.list[c].who_saw.list[w].user_saw.val && task.data.general.comment.list[c].who_saw.list[w].user_saw.val.value === this.d_wdm22.id) {
                count += 1;
              }
            }
          }
        }
        return count.toString() + ' / ' + task.data.general.comment.list.length.toString();
      } else {
        return '0 / 0';
      }
    },
    f_showComments: function (task_ind, type) {
      this.d_newTaskComment = '';
      this.selected_task_list_type = type;
      this.selected_task_index = task_ind;
      // this.f_whoCanSeeThisTask();
      this.d_selectedTaskForComment = this.d_taskList[task_ind];
      let task = this.d_selectedTaskForComment;
      let task_updated = false;
      let comment_users = [];
      let user_pic_keys = [];
      if (task.data && task.data.general && task.data.general.comment && task.data.general.comment.list) {
        for (let c in task.data.general.comment.list) {
          let user_value = task.data.general.comment.list[c].who_commented.val.value;
          if (!this.d_allOrganizationUsers[user_value] || (this.d_allOrganizationUsers[user_value] && !this.d_allOrganizationUsers[user_value].pic)) {
            comment_users.push(user_value);
            user_pic_keys.push('user_' + user_value + '_picture');
          }
          let comment_seen = false;
          if (task.data.general.comment.list[c].who_saw && task.data.general.comment.list[c].who_saw.list) {
            for (let w in task.data.general.comment.list[c].who_saw.list) {
              if (task.data.general.comment.list[c].who_saw.list[w].user_saw.val && task.data.general.comment.list[c].who_saw.list[w].user_saw.val.value === this.d_wdm22.id) {
                comment_seen = true;
              }
            }
          }
          let dt = new Date();
          if (!comment_seen) {
            task_updated = true;
            if (!task.data.general.comment.list[c].who_saw) {
              task.data.general.comment.list[c].who_saw = { 'list': [] };
            }
            let prepare_seen_data = {
              'user_saw': {
                'val': {
                  'value': this.d_wdm22.id,
                  'label': this.user.first_name + ' ' + this.user.last_name
                }
              },
              'seen_datetime': {
                'val': dt.toISOString()
              }
            }
            task.data.general.comment.list[c].who_saw.list.push(prepare_seen_data);
          }
        }
      }
      if (task_updated) {
        this.f_saveOperationFast(task_ind, task);
      }
      this.d_showTaskCommentsModal = true;
      /*      if (user_pic_keys.length > 0) {
              GlobalService.get_multiple_cb_documents({ 'key_list': user_pic_keys, 'bucket': 'uploads' })
                .then(resp => {
                  if (resp.data.status === 'success') {
                    for (let i in resp.data.result) {
                      if (!this.d_allOrganizationUsers[resp.data.result[i].username]) {
                        this.d_allOrganizationUsers[resp.data.result[i].username] = { 'pic': '' };
                      }
                      this.d_allOrganizationUsers[resp.data.result[i].username].pic = resp.data.result[i].picture;
                    }
                    this.d_showTaskCommentsModal = true;
                    this.addEventListenerToWriting();
                  } else {
                    console.log('error:  ' + resp.data.message);
                  }
                });
            } else {
              this.d_showTaskCommentsModal = true;
              this.addEventListenerToWriting();
            }*/
    },
    addEventListenerToWriting: function () {
      const handler = (evt) => {
        setTimeout(function () {
          d_newTaskCommentKeyLastLocation = parseInt(evt.srcElement.selectionStart);
          // console.log('handler: ', d_newTaskCommentKeyLastLocation);
        }, 0);
      };
      setTimeout(function () {
        var div = document.getElementById("write-comment");
        div.addEventListener("keydown", handler);
      }, 50);
    },
    f_addNewComment: function () {
      if (!this.d_newTaskComment) {
        alert('Lütfen yorum alanına birşeyler yazınız.');
        return;
      }
      if (!this.d_selectedTaskForComment.data.general.comment) {
        this.d_selectedTaskForComment.data.general.comment = { 'list': [] };
      }
      let dt = new Date()
      let x = {
        'who_saw': {
          'list': []
        },
        'message': {
          'val': this.d_newTaskComment
        },
        'comment_datetime': {
          'val': dt.toISOString()
        },
        'who_commented': {
          'val': {
            'label': this.user.first_name + ' ' + this.user.last_name,
            'value': this.d_wdm22.id
          }
        }
      };
      this.d_selectedTaskForComment.data.general.comment.list.push(JSON.parse(JSON.stringify(x)));
      let prepare_seen_data = {
        'user_saw': {
          'val': {
            'value': this.d_wdm22.id,
            'label': this.user.first_name + ' ' + this.user.last_name
          }
        },
        'seen_datetime': {
          'val': dt.toISOString()
        }
      };
      this.d_selectedTaskForComment.data.general.comment.list[this.d_selectedTaskForComment.data.general.comment.list.length - 1].who_saw.list.push(prepare_seen_data);
      let operation_data = this.d_selectedTaskForComment;
      let layer_type = 'operation';
      let w_id_list = [this.d_selectedWdmr307.id, operation_data.id];
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Operasyon kayıt işlemi tamamlanıyor. Lütfen bekleyiniz.' } });
      WmanagerApi.prepare_wdmr(layer_type, operation_data, w_id_list)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log(resp);
          this.d_taskList[this.selected_task_index] = operation_data;
          this.d_taskList[this.selected_task_index].cas = resp.cas;
          let operation_text = ' *** Yorum: ' + this.d_newTaskComment + ' *** ';
          this.f_sendMessageOverWconnectToOtherUsers(operation_data, operation_text);
          this.d_newTaskComment = '';
          this.$forceUpdate();
          let msg = 'İşlem tamamlandı.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon yorum işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }, resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          console.log(resp);
          let msg = JSON.stringify(resp);
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon yorum işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        });
    },
    f_showDocuments: function (task, task_ind) {
      this.d_taskDocuments.task = task;
      this.d_taskDocuments.task_ind = task_ind;
      this.d_taskDocuments.show = true;
    },
    f_createAcceptedDocumentTypes: function () {
      let accept = '';
      let file_types = ["jpg", "jpeg", "png", "docx", "doc", "pdf", "xlsx", "xls"];
      for (let i in file_types) {
        accept += '.' + file_types[i] + ',';
      }
      return accept;
    },
    f_addDocumentFastToTask: function (task_ind) {
      let task_data = this.d_taskList[task_ind];
      let file_name = this.d_tmpFile.name;
      let arr = this.d_tmpFile.name.split('.');
      let fileExtension = arr[arr.length - 1];
      if (["jpg", "jpeg", "png", "docx", "doc", "pdf", "xls", "xlsx"].indexOf(fileExtension.toLowerCase()) === -1) {
        this.d_tmpFile = '';
        this.$forceUpdate();
        alert('yasaklı dosya tipi');
        return;
      }
      if (this.d_tmpFile.size > 10485760) {
        this.d_tmpFile = '';
        this.$forceUpdate();
        alert(this.$t('wdm16.12730'));
        return;
      }
      var reader = new FileReader();
      var vm = this;
      if (!task_data.document_list) {
        task_data.document_list = [];
      }
      let doc_data = {
        'record_status': 'add_edit',
        'status': 'upload',
        'user': this.user.username,
        'document': '',
        'information': '',
        'fileExtension': fileExtension,
        'file_name': file_name
      };
      task_data.document_list.push(doc_data);
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        // console.log(reader.result);
        task_data.document_list[task_data.document_list.length - 1].document = reader.result;
        // vm.f_saveTaskGeneral(task_ind, task_data);
        vm.f_saveOperationFast(task_ind, task_data);
      }, false);
      reader.readAsDataURL(this.d_tmpFile);
      this.d_tmpFile = '';
    },
    f_deleteDocumentInTask: function (task_ind, doc_ind) {
      let task_data = this.d_taskList[task_ind];
      task_data.document_list.splice(doc_ind, 1);
      // task_data.document_list[doc_ind]['record_status'] = 'deleted';
      // this.f_saveTaskGeneral(task_ind, task_data);
      this.f_saveOperationFast(task_ind, task_data);
    },
    f_saveOperationFast: function (task_ind, operation_data) {
      let layer_type = 'operation';
      let w_id_list = [this.d_selectedWdmr307.id, operation_data.id];
      this.$store.commit('Loading', { 'status': true, 'data': { 'label': 'Operasyon kayıt işlemi tamamlanıyor. Lütfen bekleyiniz.' } });
      WmanagerApi.prepare_wdmr(layer_type, operation_data, w_id_list)
        .then(resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          // console.log(resp);
          this.d_taskList[task_ind] = operation_data;
          this.d_taskList[task_ind].cas = resp.cas;

          this.f_showTrueFalseTaskDocumentField();
          if (this.selected_task_index !== '' && this.d_workTimeEditMode) {
            this.f_calculateTotalWorkTime(this.d_taskList[this.selected_task_index]);
            this.d_workTimeEditMode = false;
            this.d_newWorkTime = {
              'start': '',
              'end': '',
              'work_time_note': ''
            };
          }

          if (this.d_taskDocuments.show) {
            this.d_taskDocuments.task = operation_data;
          }
          this.$forceUpdate();
          let msg = 'İşlem tamamlandı.';
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon yorum işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        }, resp => {
          this.$store.commit('Loading', { 'status': false, 'data': {} });
          console.log(resp);
          let msg = JSON.stringify(resp);
          let modal_data = { 'type': 'alert', 'text': msg, 'centered': true, 'title': 'Operasyon yorum işlemi hakkında' };
          this.$store.commit('modal', modal_data);
          this.$store.commit('modal_show', true);
        });
    },
    f_saveTaskGeneral: function (task_ind, task_data) {
      OrganizationService.save_task(task_data)
        .then(resp => {
          if (resp.data.status === 'success') {
            // console.log(resp.data.result);
            this.d_taskList[task_ind] = resp.data.result;
            if (this.d_taskDocuments.show) {
              this.d_taskDocuments.task = resp.data.result;
            }
            this.f_showTrueFalseTaskDocumentField();
            this.$forceUpdate();
          } else {
            console.log('error :' + resp.data.message);
          }
        });
    },
    f_showTrueFalseTaskDocumentField: function () {
      this.d_showTaskDocumentField = false;
      setTimeout(function () {
        this.d_showTaskDocumentField = true;
      }.bind(this), 5)
    },
    f_previewImage: function (wdmr, doc_ind, file_name) {
      if (wdmr.document_list[doc_ind].document) {
        this.document_show_data.file_name = wdmr.document_list[doc_ind].file_name;
        this.document_show_data.file = wdmr.document_list[doc_ind].document;
        this.show_image_show_modal = true;
      } else {
        let data = { 'key_list': [] };
        let key = wdmr.type + '_' + wdmr.id + '_doc' + doc_ind.toString();
        data.key_list.push(key);
        FileTransferService.get_file_with_key(data)
          .then(resp => {
            if (resp.data.status === 'success') {
              if (resp.data.result[key].file) {
                this.document_show_data.file_name = file_name;
                this.document_show_data.file = resp.data.result[key].file;
                this.show_image_show_modal = true;
              }
            } else {
              alert('error: ', resp.data.message);
            }
          });
      }
    },
    f_rotateImage: function () {
      if (this.rotate_degree === 360) {
        this.rotate_degree = 90;
      } else {
        this.rotate_degree += 90;
      }
    },
    f_scaleImageBig: function () {
      // this.f_showTrueFalse();
      this.d_scale += 0.1;
    },
    f_scaleImageSmall: function () {
      // this.f_showTrueFalse();
      this.d_scale -= 0.1;
    },
    f_downloadDocument: function (wdmr, doc_ind, file_name) {
      if (wdmr.document_list[doc_ind].document) {
        FileSaver.saveAs(wdmr.document_list[doc_ind].document, file_name);
      } else {
        let data = { 'key_list': [] };
        let key = wdmr.type + '_' + wdmr.id + '_doc' + doc_ind.toString();
        data.key_list.push(key);
        FileTransferService.get_file_with_key(data)
          .then(resp => {
            if (resp.data.status === 'success') {
              FileSaver.saveAs(resp.data.result[key].file, file_name);
            } else {
              alert('error: ', resp.data.message);
            }
          });
      }
    },
    f_controlOnlyMyPermission: function (task, perm) {
      if (task['organization_data']) {
        for (let i in task['organization_data']['perms_and_index_list']) {
          if (task['organization_data']['perms_and_index_list'][i].perms.indexOf(perm) !== -1) {
            return true;
          }
        }
      }
      return false;
    },
    f_isActiveUserEqualOrUpperOfTaskLayerList: function (task, can_use_me = false, team_member = false) {
      // wca_start
      // task.index_list => ['0,1,2', '4,2,1']; if a task assigned to at least one layer, we have this parameter
      // wca_end
      if (!task.index_list) {
        return true;
      }
      let task_layer_list = task.index_list;
      if (!task_layer_list || (task_layer_list && task_layer_list.length === 0)) {
        try {
          if (task.created_by === this.user.username && task.data.general.status.val.value === 'not_assigned') {
            return true;
          }
        } catch (err) {
          return false;
        }
        return false;
      }
      let my_item_index_list = [];
      if (task['organization_data']) {
        for (let i in task['organization_data']['perms_and_index_list']) {
          my_item_index_list.push(task['organization_data']['perms_and_index_list'][i].index);
        }
      }
      if (my_item_index_list.length === 0) {
        return false;
      }
      for (let i in my_item_index_list) {
        let one_back_index = '';
        if (team_member) {
          let arr = my_item_index_list[i].split(',');
          arr.splice(arr.length - 1, 1);
          one_back_index = arr.join(',');
        }
        for (let k in task_layer_list) {
          let layer_index = task_layer_list[i];
          // TODO layer_index split length ile my irem index list split length eşitliğ veyanın içinde kontrol edilecek
          if (layer_index.indexOf(my_item_index_list[i]) === 0 || (team_member && layer_index.indexOf(one_back_index) === 0)) {
            if (!can_use_me) {
              if (my_item_index_list[i] !== layer_index) {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      }
      return false;
    },
    f_giveTaskToSelectedLayer: function (type, task_ind) {
      let task_data = JSON.parse(JSON.stringify(this.d_taskList[task_ind]));
      let task_key = 'organization_' + task_data['organization_id'] + '_task_' + task_data['id'];
      if (!this.selected_organization_item.task_list || (this.selected_organization_item.task_list && this.selected_organization_item.task_list.indexOf(task_key) === -1)) {
        if (type === 'transfer') {
          // console.log(this.organization_data);
          this.f_deleteTaskFromAllUsers(this.organization_data.list, task_key);
          this.$delete(this.d_taskList[task_ind], 'user_index_list');
        }
        if (!this.selected_organization_item.task_list) {
          this.selected_organization_item.task_list = [];
        }
        this.selected_organization_item.task_list.push(task_key);
        if (!this.d_taskList[task_ind].user_index_list) {
          this.d_taskList[task_ind].user_index_list = {};
        }
        this.d_taskList[task_ind].user_index_list[this.selected_organization_item.value] = {
          'index_list': [],
          'label': this.selected_organization_item.label,
          'value': this.selected_organization_item.value
        };
        if (this.d_taskList[task_ind].user_index_list[this.selected_organization_item.value].index_list.indexOf(this.selected_organization_item.index) === -1) {
          this.d_taskList[task_ind].user_index_list[this.selected_organization_item.value].index_list.push(this.selected_organization_item.index);
        }
        this.$forceUpdate();
        this.f_sendParentInfo('save_organization');
      } else {
        alert('Bu görev bu kullanıcıda zaten eklidir.');
      }
    },
    f_deleteTaskFromAllUsers: function (list_data, task_key) {
      for (let i in list_data) {
        if (list_data[i].task_list && list_data[i].task_list.indexOf(task_key) !== -1) {
          list_data[i].task_list.splice(list_data[i].task_list.indexOf(task_key), 1);
        }
        if ('list' in list_data[i] && list_data[i].list.length > 0) {
          this.f_deleteTaskFromAllUsers(list_data[i].list, task_key);
        }
      }
    },
    f_addStatusAsLogToTask: function (task_data, selected_status, which_user_log) {
      task_data.data.general.status = { 'val': selected_status };
      if (!task_data.data.general.log) {
        task_data.data.general.log = { 'list': [] };
      }
      let today = new Date();
      let x = {
        'log_user': {
          'val': {
            'label': this.user.first_name + ' ' + this.user.last_name,
            'value': this.d_wdm22.id
          }
        },
        'which_user_log': which_user_log,
        'log_status': {
          'val': selected_status
        },
        'log_datetime': {
          'val': today.toISOString()
        }
      };
      task_data.data.general.log.list.push(JSON.parse(JSON.stringify(x)));
    },
    f_sendParentInfo: function (op) {
      if (this.watch_task_list[op] === 0) {
        this.watch_task_list[op] = 1;
      } else {
        this.watch_task_list[op] = 0;
      }
    },
    f_taskStatusThis: function (status_list, task_data) {
      try {
        if (status_list.indexOf(task_data.data.general.status.val.value) !== -1) {
          return true;
        }
      } catch (err) {
        return false;
      }
    },
    f_controlState: function (type, status, task_data) {
      let task_status = task_data.data.general.status.val.value;
      // if the same status, return false
      if (task_status === status) {
        return false;
      }
      if (['assigned', 'recommended'].indexOf(status) !== -1) {
        return false;
      }
      if (['not_assigned'].indexOf(status) !== -1 && type === 'all_task_list') {
        return false;
      }
      if (['completed'].indexOf(task_status) === -1 && ['checking_task_completion'].indexOf(status) !== -1) {
        return false;
      }
      if (['checking_task_completion'].indexOf(task_status) === -1 && ['approved_task_completion'].indexOf(status) !== -1) {
        return false;
      }
      return true;
    },
    f_showWorkTime: function (task_ind) {
      this.d_workTimeEditMode = false;
      this.d_newWorkTime = {
        'start': '',
        'end': '',
        'work_time_note': ''
      };
      this.selected_task_index = task_ind;
      this.f_calculateTotalWorkTime(this.d_taskList[this.selected_task_index]);
      this.d_showWorkTimeModal = true;
    },
    f_calculateTotalWorkTime: function (task) {
      if (this.d_taskList[this.selected_task_index].data.general.work_time && this.d_taskList[this.selected_task_index].data.general.work_time.list && this.d_taskList[this.selected_task_index].data.general.work_time.list.length > 0) {
        let total_miliseconds = 0;
        for (let i in this.d_taskList[this.selected_task_index].data.general.work_time.list) {
          let start = '';
          let end = '';
          try {
            start = this.d_taskList[this.selected_task_index].data.general.work_time.list[i].start.val;
            end = this.d_taskList[this.selected_task_index].data.general.work_time.list[i].end.val;
          } catch (err) {}
          if (start && end) {
            let start_date = new Date(start);
            let end_date = new Date(end);
            let start_date_mSec = start_date.getTime();
            let end_date_mSec = end_date.getTime();
            total_miliseconds += end_date_mSec - start_date_mSec;
          }
        }
        if (total_miliseconds >= 86400000) {
          let k = parseInt((total_miliseconds / 86400000).toString().split('.')[0]);
          this.d_taskWorkTime.day = k.toString();
          total_miliseconds -= (k * 86400000);
        }
        if (total_miliseconds >= 3600000) {
          let k = parseInt((total_miliseconds / 3600000).toString().split('.')[0]);
          this.d_taskWorkTime.hour = k.toString();
          total_miliseconds -= (k * 3600000);
        }
        if (total_miliseconds >= 60000) {
          let k = parseInt((total_miliseconds / 60000).toString().split('.')[0]);
          this.d_taskWorkTime.minute = k.toString();
          total_miliseconds -= (k * 60000);
        }
        if (total_miliseconds >= 1000) {
          let k = parseInt((total_miliseconds / 1000).toString().split('.')[0]);
          this.d_taskWorkTime.second = k.toString();
          total_miliseconds -= (k * 1000);
        }
      }
    },
    f_deleteWorkTime: function (worktime_ind) {
      this.d_taskList[this.selected_task_index].data.general.work_time.list.splice(worktime_ind, 1);
      this.f_saveOperationFast(this.selected_task_index, task_data);
    },
    f_editWorkTime: function (worktime_ind) {
      this.d_selectedWorkItemIndex = worktime_ind;
      this.d_workTimeEditMode = true;
      this.d_newWorkTime.start = this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].start.val;
      if (this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].end && this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].end.val) {
        this.d_newWorkTime.end = this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].end.val;
      }
      if (this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].work_time_note && this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].work_time_note.val) {
        this.d_newWorkTime.work_time_note = this.d_taskList[this.selected_task_index].data.general.work_time.list[worktime_ind].work_time_note.val;
      }
      this.$forceUpdate();
    },
    f_addEditNewWorkTime: function () {
      let task_data = this.d_taskList[this.selected_task_index];
      if (this.d_newWorkTime.start) {
        if (!task_data.data.general.work_time) {
          task_data.data.general.work_time = { 'list': [] };
        }
        let start = '';
        let end = '';
        let new_start = '';
        let new_startMsec = 0;
        let new_end = '';
        let new_endMsec = 0;
        // console.log(this.d_newWorkTime);
        if (this.d_newWorkTime.start && this.d_newWorkTime.end) {
          for (let i in task_data.data.general.work_time.list) {
            try {
              start = task_data.data.general.work_time.list[i].start.val;
              end = task_data.data.general.work_time.list[i].end.val;
              new_start = new Date(this.d_newWorkTime.start);
              new_startMsec = new_start.getTime();
              new_end = new Date(this.d_newWorkTime.end);
              new_endMsec = new_end.getTime();
            } catch (err) {}
            // console.log(start, end);
            if (start && end) {
              let start_date = new Date(start);
              let end_date = new Date(end);
              let start_date_mSec = start_date.getTime();
              let end_date_mSec = end_date.getTime();
              // console.log('start_date_mSec: ', start_date_mSec);
              // console.log('end_date_mSec: ', end_date_mSec);
              // console.log('new_startMsec: ', new_startMsec);
              // console.log('new_endMsec: ', new_endMsec);
              if ((new_startMsec >= start_date_mSec && new_startMsec < end_date_mSec) || (new_endMsec > start_date_mSec && end_date_mSec >= new_endMsec)) {
                alert('Daha önce belirttiğiniz çalışma aralığını lütfen belirtmeyiniz.');
                return;
              }
            }
          }
        }
        let prepare_work_time = {
          'start': { 'val': this.d_newWorkTime.start },
          'end': { 'val': this.d_newWorkTime.end },
          'work_time_note': { 'val': this.d_newWorkTime.work_time_note }
        };
        if (this.d_workTimeEditMode) {
          task_data.data.general.work_time.list[this.d_selectedWorkItemIndex] = prepare_work_time;
        } else {
          task_data.data.general.work_time.list.push(prepare_work_time);
        }
        this.f_saveOperationFast(this.selected_task_index, task_data);
      }
    },
    f_showWorkTimeEnd: function () {
      this.d_showWorkTimeEnd = false;
      setTimeout(function () {
        this.d_showWorkTimeEnd = true;
      }.bind(this), 1)
    },
    f_editTask: function (task_ind, type = 'edit_selected_item') {
      this.selected_task_index = task_ind;
      this.data_type = 'wdm17';
      this.wisdom_data = JSON.parse(JSON.stringify(this.d_taskList[task_ind]));
      for (let i in this.option_data[this.data_type].param_group.param_order) {
        if (!this.wisdom_data['data'][this.option_data[this.data_type].param_group.param_order[i]]) {
          this.wisdom_data['data'][this.option_data[this.data_type].param_group.param_order[i]] = {};
        }
      }
      this.show_wisdom_data_modal = true;
    },
    f_saveTask: function () {
      let return_data = ClsWdmrForever.turn(this.wisdom_data, this.option_data[this.data_type], ['name', 'delete']);
      let wisdom_data = return_data.wdmr;
      wisdom_data.label = return_data.name;
      let wdmr_require_alerts = return_data.wdmr_require_alerts;
      let only_one_param_is_filled = return_data.only_one_param_is_filled;
      if (!only_one_param_is_filled) {
        let modal_data = { 'type': 'alert', 'text': 'Veri modelini kaydedebilmek için en az bir veriniz dolu olmalıdır.', 'centered': true, 'title': 'Veri modeli kayıt işlemi zorunlu alanları tamamlayınız.' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
        return;
      }
      if (wdmr_require_alerts && wdmr_require_alerts.length > 0) {
        let require_txt = '';
        for (let r in wdmr_require_alerts) {
          require_txt += ' * ' + wdmr_require_alerts[r].label;
        }
        let modal_data = { 'type': 'alert', 'text': require_txt, 'centered': true, 'title': 'Veri modeli kayıt işlemi zorunlu alanları tamamlayınız.' };
        this.$store.commit('modal', modal_data);
        this.$store.commit('modal_show', true);
        return;
      }
      OrganizationService.save_task(wisdom_data)
        .then(resp => {
          if (resp.data.status === 'success') {
            this.show_wisdom_data_modal = false;
            if (this.d_taskList[this.selected_task_index] && resp.data.result.id === this.d_taskList[this.selected_task_index].id) {
              this.d_taskList[this.selected_task_index] = resp.data.result;
            }
            this.$forceUpdate();
          } else {
            alert('error ' + resp.data.message);
          }
        });
    },
    f_prepareTagList: function () {
      this.d_tagOperation.all_tags = [];
      if (this.d_selectedWdmr307.data.general && this.d_selectedWdmr307.data.general.tag && this.d_selectedWdmr307.data.general.tag.list && this.d_selectedWdmr307.data.general.tag.list.length > 0) {
        for (let i in this.d_selectedWdmr307.data.general.tag.list) {
          this.d_tagOperation.all_tags.push(this.d_selectedWdmr307.data.general.tag.list[i].tag_name.val);
        }
      }
    },
    f_showTagOperation: function (operation_ind) {
      this.d_tagOperation.operation_ind = operation_ind;
      if (this.d_taskList[operation_ind].data.general.tag && this.d_taskList[operation_ind].data.general.tag.list && this.d_taskList[operation_ind].data.general.tag.list.length > 0) {
        for (let i in this.d_taskList[operation_ind].data.general.tag.list) {
          this.d_tagOperation.selected_tags.push(this.d_taskList[operation_ind].data.general.tag.list[i].tag_name.val);
        }
      }
      this.d_tagOperation.show = true;
    },
    f_updateOperationTags: function () {
      let operation_data = JSON.parse(JSON.stringify(this.d_taskList[this.d_tagOperation.operation_ind]));
      if (this.d_tagOperation.selected_tags.length === 0) {
        if (operation_data.data.general.tag) {
          this.$delete(operation_data.data.general, 'tag');
        }
      } else {
        operation_data.data.general.tag = { 'list': [] };
        for (let i in this.d_tagOperation.selected_tags) {
          let x = { 'tag_name': { 'val': this.d_tagOperation.selected_tags[i] } };
          operation_data.data.general.tag.list.push(x);
        }
      }
      this.f_saveOperationFast(this.d_tagOperation.operation_ind, operation_data);
    },
    f_addRemoveTag: function (tag) {
      if (this.d_tagOperation.selected_tags.indexOf(tag) === -1) {
        this.d_tagOperation.selected_tags.push(tag);
      } else {
        this.d_tagOperation.selected_tags.splice(this.d_tagOperation.selected_tags.indexOf(tag), 1);
      }
      this.$forceUpdate();
    },
  },
  watch: {
    'd_selectedTab': function () {
      if (this.d_selectedTab === 'organization_details') {
        let wmanager_local_storage = JSON.parse(localStorage.getItem('wmanager'));
        let layer_type = 'organization';
        let w_id_list = [this.d_selectedWdmr307.id];
        this.d_WmanagerLayerData.organization.url_show_iframe = this.WDMR_LINKS['show'] + 'layer_id=' + this.d_WmanagerLayerData[layer_type].layer_id + '&w_id_list=' + w_id_list.join(',') + '&wisdom=' + wmanager_local_storage.access_token + '&modsiw=' + wmanager_local_storage.refresh_token;
      } else if (this.d_selectedTab === 'config_list') {
        this.f_getAppConfigList();
      } else if (this.d_selectedTab === 'version_list') {
        this.f_getAppVersionList();
      } else if (this.d_selectedTab === 'friend_list') {
        this.f_getAppFriendList();
      } else if (this.d_selectedTab === 'route_list') {
        this.f_getAppRouteList();
      } else if (this.d_selectedTab === 'codepage_list') {
        this.f_getAppCodepageList();
      } else if (this.d_selectedTab === 'statuscode_list') {
        this.f_getAppStatuscodeList();
      } else if (this.d_selectedTab === 'id_list') {
        this.f_getAppIdList();
      } else if (this.d_selectedTab === 'location_list') {
        this.f_getAppLocationList();
      } else if (this.d_selectedTab === 'requirement_list') {
        this.f_getAppRequirementList();
      }
    },
    'd_filter.operation_no': function () {
      let text = this.d_filter.operation_no;
      setTimeout(function () {
        if (this.d_filter.operation_no === '') {
          if (!this.$route.query === undefined || (this.$route.query !== undefined && this.$route.query.organization_id !== undefined && this.$route.query.operation_no !== undefined)) {
            let route_data = {
              'query': {
                'organization_id': this.$route.query.organization_id
              }
            };
            this.$router.push(route_data);
          }
        } else {
          if (!this.$route.query === undefined || (this.$route.query !== undefined && this.$route.query.organization_id !== undefined && (this.$route.query.operation_no === undefined || this.$route.query.operation_no !== this.d_filter.operation_no))) {
            let route_data = {
              'query': {
                'organization_id': this.$route.query.organization_id,
                'operation_no': this.d_filter.operation_no
              }
            };
            this.$router.push(route_data);
          }
        }
        if (text === this.d_filter.operation_no) {
          this.f_updateOperations();
        }
      }.bind(this), 1000);
    },
    'd_filter.search_text': function () {
      let text = this.d_filter.search_text;
      setTimeout(function () {
        if (text === this.d_filter.search_text) {
          this.f_updateOperations();
        }
      }.bind(this), 2000);
    },
    'd_pagination.current': function () {
      this.d_pagination.start = (this.d_pagination.current - 1) * this.d_pagination.perpage;
      this.d_pagination.end = (this.d_pagination.perpage * this.d_pagination.current) - 1;
      if (this.d_selectedWdmr307 && this.d_selectedWdmr307.id) {
        this.f_getWdm17OfThisOrganization(this.d_selectedWdmr307.id);
      }
      // this.f_updateOperations();
    }
  }
}

</script>

<style type="text/css">
#operation_list::-webkit-scrollbar-track {
  border-radius: 0 10px 10px 0;
  background-color: #d9e9ea;
}

#operation_list::-webkit-scrollbar {
  width: 5px;
  /*background-color: #F5F5F5;*/
}

#operation_list::-webkit-scrollbar-thumb {
  border-radius: 0 10px 10px 0;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #4788ac;
}

.task-comment {
  text-align: left;
  float: left;
  margin: 3px;
  font-size: 10px;
}

.task-comment:hover {
  background: #9ff5ff;
}

.td-class {
  text-align: center;
  vertical-align: bottom;
  min-width: 100px;
  white-space: pre-line;
  border-right: solid 1px #c3d8d8;
  font-size: 10px;
  color: black,
}

.th-class {
  text-align: center;
  vertical-align: bottom;
  min-width: 100px;
  background: #9ff5ff;
  border-right: solid 1px #c3d8d8;
  background-color: aliceblue;
  font-size: 12px;
  color: black,
}

.task-worktime {
  text-align: left;
  float: left;
  margin: 3px;
  font-size: 10px;
  cursor: pointer;
}

.task-worktime:hover {
  background: #9ff5ff;
}

.operation-useful-link {
  text-align: left;
  float: left;
  margin: 3px;
  font-size: 10px;
  cursor: pointer;
}

.operation-tag {
  text-align: left;
  float: left;
  margin: 3px;
  font-size: 10px;
  cursor: pointer;
}

.operation-useful-link:hover {
  background: #9ff5ff;
}

.wdmr-link {
  float: right;
  margin: 3px;
  font-size: 10px;
  cursor: pointer;
}

.wdmr-link:hover {
  background: #9ff5ff;
}

.task-visibility {
  text-align: left;
  float: left;
  margin: 3px;
  font-size: 10px;
  cursor: pointer;
}

.task-visibility:hover {
  background: #9ff5ff;
}

.normal-mode {}

.full-screen-mode {
  position: fixed;
  z-index: 1021;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background-color: rgba(0, 0, 0, .5);*/
  /*display: table;*/
  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
}

</style>

